//#region import
import {
  ActionIcon,
  Box,
  Button,
  CSSProperties,
  Card,
  Checkbox,
  Collapse,
  Divider,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Menu,
  Modal,
  NumberFormatter,
  NumberInput,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  Tabs,
  Text,
  TextInput,
  Textarea,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  useDebouncedCallback,
  useDebouncedState,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconAlertCircle,
  IconBan,
  IconCheck,
  IconCreditCard,
  IconCurrencyDollar,
  IconDiscount,
  IconEdit,
  IconMaximize,
  IconMaximizeOff,
  IconMenu2,
  IconPlus,
  IconSearch,
  IconTrash,
  IconTruck,
  IconWindow,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useLocation, useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SocketExtension } from "../../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../../_base/socket/ToplicList";
import { apiAuth, UserAuthResponse } from "../../../api/apiAuth";
import { styleCellTable } from "../../../_setup/navdata/baseStyleCellTable";
import EditableTextWithOptions from "../../../common/selectValue";
import SelectBuildPc from "../../../common/selectValue/SelectBuildPc";
import { _localizationSales } from "../../../config/location";
import { cobalt_blue, orange } from "../../../const/variables";
import { DepartmentModel } from "../../../model/DepartmentModel";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  OrderHeader,
  dataOrderDetailTable,
} from "../../../model/SaleOrderModel";
import { ProductModel } from "../../../model/TblDMItem";
import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
import {
  ItemDetailPriceModel,
  TblItemPromotionModel,
  itemAddOnPromotionModel,
  itemGiftPromotionModel,
} from "../../../model/TblItem";
import "../../../Styles/TableBodyCell.module.css";
import { LineType, OrderStatus } from "../orderStatus";
import {
  containsDT,
  formatDateString,
  formatOrderDate,
  getDiscountDecisionSupportTableWholesale,
  getTotalQuality,
  handleCheckBackgroundColor,
  handleCheckChooseProductBuon,
  handleCheckIsSuccessValidateItem,
  handleGetNameBranch,
  handleGetNameDepartment,
  handleGetNameEmployeeAll,
  handleGetTechnicialRequireId,
  handleGetTechnicialRequireName,
  handleKeyDown,
  handlePaymentChange,
  handleQuantityChange,
  handlerRenderOptionSelect,
  parseAttribute19,
} from "./Helper/HelperFunction";
import ShipCompanyTable from "./ModalComponent/ChooseShipCompany";
import ChooseShipDepartment from "./ModalComponent/ChooseShipDepartment";
import DiscountSuggestionModal from "./ModalComponent/DiscountSuggestionModal";
import DiscountSelectionModal from "./ModalComponent/DiscountSelectionModal";
import CustomerInformation from "./ModalComponent/ModalCustomerInformation";
import ModalDeliveryInformation from "./ModalComponent/ModalDeliveryInformation";
import { PaymentMethod } from "./ModalComponent/ModalPayment";
import { PaymentMethodMb } from "./ModalComponent/ModalPaymentMb";
import PaymentDetails from "./ModalComponent/PaymentDetails";
import VoucherRefactor from "./ModalComponent/Voucher";
import {
  TableSelectProps,
  customerCheck,
  dataCreateSalesOrder,
} from "./Model/modelRetailOrder";
import styles from "./RetailOrder.module.css";
import { IconPrinter } from "@tabler/icons-react";
import SelectPaymentMethod from "../../../common/selectValue/SelectPaymentMethod";
import CustomerDetail from "./ModalComponent/CustomerDetail";
import { attributes } from "@syncfusion/ej2-base";
import PromotionDescriptionPopover from "./ModalComponent/PromotionDescriptionPopover";

const WholeSale = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFetchDataCalledRef = React.useRef(false);
  const isSetDefaultBuildPc = React.useRef(false);

  //#region   khai báo state
  const [accountantId, setAccountantId] = useState(0);
  const [accountantName, setAccountantName] = useState("");
  const [isPaymentMbSuccess, setIsPaymentMbSuccess] = useState(false);
  const [userAuth, setUserAuth] = useState<UserAuthResponse | null>(null);

  const [selectedBankReserve, setSelectedBankReserve] = useState<string | null>(
    null,
  ); // Ngân hàng dự phòng
  const [modalType, setModalType] = useState(""); // COD, "Công nợ", "Trả góp"
  const [installmentInfo, setInstallmentInfo] = useState({
    installmentType: "",
    companyName: "",
    contractCode: "",
    cardType: "",
  });

  // State cho thông tin công nợ
  const [debtInfo, setDebtInfo] = useState({
    dueDate: "",
  });

  // State cho email list khi xuất VAT
  const [vatEmailList, setVatEmailList] = useState<string>("");

  // State cho thông tin thuế VAT
  const [taxInfo, setTaxInfo] = useState({
    TaxCode: "",
    TaxCompany: "",
    TaxEmail: "",
    TaxAddress: "",
  });
  const [taxInfoModalOpened, setTaxInfoModalOpened] = useState(false);
  const [emailError, setEmailError] = useState<string>("");
  const [promoDescOpened, setPromoDescOpened] = useState(false);

  // Danh sách các ngân hàng (ví dụ)
  const bankOptions = [
    { value: "VCB-930", label: "VCB-930" },
    { value: "TPB-604", label: "TPB-604" },
    { value: "VCB-813", label: "VCB-813" },
    { value: "VCB-762", label: "VCB-762" },
    { value: "PAYOO", label: "PAYOO" },
    { value: "VN PAY", label: "VN PAY" },
    { value: "Alepay", label: "Alepay" },
  ];

  // State cho discount suggestion modal
  const [discountModalOpened, setDiscountModalOpened] = useState(false);
  const [discountSuggestionData, setDiscountSuggestionData] =
    useState<any>(null);
  const [discountLoading, setDiscountLoading] = useState(false);

  console.log("discountSuggestionData", discountSuggestionData);

  // State cho discount selection modal
  const [discountSelectionOpened, setDiscountSelectionOpened] = useState(false);
  const [selectedRowForDiscount, setSelectedRowForDiscount] =
    useState<any>(null);

  // State để lưu discount options cho sản phẩm được chọn
  const [currentDiscountOptions, setCurrentDiscountOptions] = useState<any[]>(
    [],
  );

  // Debug: Log khi currentDiscountOptions thay đổi
  React.useEffect(() => {
    console.log("currentDiscountOptions changed:", currentDiscountOptions);
  }, [currentDiscountOptions]);

  console.log("selectedRowForDiscount222222", selectedRowForDiscount);

  const [transactionCodeReserve, setTransactionCodeReserve] = useState<
    string | null
  >(null); // Mã giao dịch
  const [transactionCodeMb, setTransactionCodeMb] = useState<string | null>(
    null,
  ); // Mã giao dịch MB động

  const [selectedBank, setSelectedBank] = useState("");
  const [modeSearch, setModeSearch] = useState("SP"); //SP là tìm sản phẩm , DV là tìm dịch vụ
  const [userLogin, setUserLogin] = useState<any>();
  const [listSerial, setListSerial] =
    useState<{ value: string; label: string }[]>();
  const [totalKM, setTotalKM] = useState(0);
  const [totalKMLine, setTotalKMLine] = useState(0);
  const [totalXGDetail, setTotalXGDetail] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  // 5 hình thức thanh toán
  const [cashPayment, setCashPayment] = useState(0);
  const [bankTransfer, setBankTransfer] = useState(0);
  const [cardPayment, setCardPayment] = useState(0);
  const [vnpayPayment, setVnpayPayment] = useState(0);
  const [anotherPayment, setAnotherPayment] = useState(0);
  //
  const [totalPaid, setTotalPaid] = useState(0);
  const [deferredPayment, setDeferredPayment] = useState(0);
  const [contractcode, setContractcode] = useState("");
  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);
  const [listBranch, setListBranch] = useState<any[]>([]);
  const [branchId, setBranchId] = useState<number>();
  const [branchName, setBranchName] = useState<string>("");
  const [employeeSalesId, setEmployeeSalesId] = useState("");
  const [employeeSalesRevenueId, setEmployeeSalesRevenueId] = useState("");
  const [listDepartment, setListDepartment] = useState<DepartmentModel[]>([]);
  const [departmentId, setDepartmentId] = useState<Number>();
  const [employeeSalesName, setEmployeeSalesName] = useState("");
  const [employeeSalesRevenueName, setEmployeeSalesRevenueName] = useState("");
  const [department, setDepartment] = useState("");
  const [orderStatus, setOrderStatus] = useState<string>("noCreate");
  const [shipping, setShipping] = useState("Nhận tại cửa hàng");
  const [shipingVendor, setShipingVendor] = useState("");
  const [payLaterMethod, setPayLaterMethod] = useState("Không");
  const [saleChanelList, setSaleChanelList] = useState<any[]>();
  const [saleChanelId, setSaleChanelId] = useState<number>();
  const [saleChanel, setSaleChanel] = useState("Khách đến showroom");
  const [height, setHeight] = useState(0);
  const [isError, setIsError] = useState(false);
  const [listAdd, setListAdd] = useState<dataOrderDetailTable[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dataProducts, setDataProducts] = useState<ProductModel[]>([]);
  const [valueDebounced, setValueDebounced] = useDebouncedState("", 500);
  const [paymentDone, setPaymentDone] = useState<string[]>([]);
  const [idPrint, setIdPrint] = useState<number | null>(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [loading, { close: closeLoading, open: openLoading }] =
    useDisclosure(false);
  const [isCollapse, { toggle: toggleCollapse }] = useDisclosure(false);

  const [dataAllocate, setDataAllocate] = useState([]);
  const [isDisablePhanBo, setIsDisablePhanBo] = useState(false);

  const [isHaveShipping, setIsHaveShipping] = useState(false);

  //#region  state object
  const [listBuyerName, setListBuyerName] = useState([]);
  const [listAddress, setListAddress] = useState([]);
  const [dataDeliveryInformation, setDataDeliveryInformation] = useState<any>();
  const [dataPayment, setDataPayment] = useState<any>();
  const [dataPaymentLatter, setDataPaymentLatter] = useState<any>();
  const [orderHeaderRef, setOrderHeaderRef] = useState<any>();
  const [orderHeader, setOrderHeader] = useState<OrderHeader>({
    id: 0, // ID của đơn hàng - OK
    orderNumber: "", // Số đơn hàng - đã ghép vào field "Mã đơn hàng"
    orderTypeId: 1, // Loại đơn hàng (2 là đơn hàng lẻ)
    orderDate: "2024-01-01T01:00:00.000Z", // Ngày đặt hàng - đã ghép vào field "Thời gian"
    orderStatus: "DON_HANG_TAM", // Trạng thái đơn hàng (pending: đang chờ) -đã ghép vào trạng thái góc trên phải
    note: "", // Ghi chú đơn hàng - đã ghép vào field "Ghi chú"
    orgId: 0, // ID tổ chức
    invOrgId: 0, // ID tổ chức liên quan đến kho hàng
    deptId: 0, // ID phòng ban
    divisionId: 0, // ID bộ phận
    saleChanelId: 0, // ID kênh bán hàng
    sourceOrderNumber: "", // Số đơn hàng nguồn
    sourceDocument: "", // Tài liệu nguồn
    sourceInvoices: "", // Hóa đơn nguồn
    custId: 0, // ID khách hàng
    custGroupId: 0, // ID nhóm khách hàng
    contactPersonId: 0, // ID người liên hệ
    billToLocationId: 0, // ID địa điểm hóa đơn
    shipToLocationId: 0, // ID địa điểm giao hàng
    invoiceSerial: "", // Số serial hóa đơn
    invoiceNumber: "", // Số hóa đơn
    invoiceDate: "2024-07-16T04:10:09.167Z", // Ngày hóa đơn
    taxCode: "", // Mã số thuế
    taxAddr: "", // Địa chỉ thuế
    amountTotal: 0, // Tổng số tiền
    amountDiscount: 0, // Số tiền giảm giá
    amountVoucher: 0, // Số tiền voucher
    amountVat: 0, // Số tiền thuế VAT
    currentcyCode: "", // Mã tiền tệ
    currentcyRate: 0, // Tỷ giá tiền tệ
    amountPaid: 0, // Số tiền đã thanh toán
    amountRemaining: 0, // Số tiền còn lại
    paymentType: "", // Loại thanh toán
    paymentStatus: "", // Trạng thái thanh toán
    paymentMethod: "", // Phương thức thanh toán
    paymentDue: 0, // Hạn thanh toán
    saleId: 0, // ID người bán hàng
    managerId: 0, // ID quản lý
    approveId: 0, // ID người duyệt
    approveNote: "", // Ghi chú người duyệt
    rejectNote: "", // Ghi chú từ chối
    shipngType: "", // Loại vận chuyển
    shipingVendor: "", // Nhà cung cấp vận chuyển
    shippingCode: "", // Mã vận chuyển
    shippingStatus: "", // Trạng thái vận chuyển
    shippingPriority: "", // Ưu tiên vận chuyển
    shippingDate: "2024-07-16T04:10:09.167Z", // Ngày vận chuyển
    shippingNote: "", // Ghi chú vận chuyển
    technicalChecked: 0, // Kiểm tra kỹ thuật
    technicalNote: "", // Ghi chú kỹ thuật
    clientId: 0, // ID khách hàng
    createBy: 0, // ID người tạo
    createDate: "2024-07-16T04:10:09.167Z", // Ngày tạo
    lastUpdateBy: 0, // ID người cập nhật cuối cùng
    lastUpdateDate: "2024-07-16T04:10:09.167Z", // Ngày cập nhật cuối cùng
    salesShift: "", // Ca bán hàng
    printInvoiceCheck: 0, // Kiểm tra in hóa đơn
    technicalRequired: 0,
    contractcode: "",
    discountAdded: 0,
    discountAddedTotal: 0,
    orderNumberLink: "",
    attribute97: "",
  });

  const [customerCheck, setCustomerCheck] = useState<customerCheck>({
    id: 0,
    companyName: null,
    code: null,
    name: null,
    contact: null,
    address: null,
    telephoneNumber: null,
    fax: null,
    email: null,
    taxCode: "",
    type: null,
    active: null,
    description: null,
    sex: null,
    groupId: 0,
    country: null,
    province: null,
    district: null,
    commune: null,
    provinceName: null,
    districtName: null,
    communeName: null,
    birthOfDate: null,
    groupName: null,
    debtLimit: null,
    debtTerm: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
  });

  const deliveryFee =
    listAdd.length > 0 ? dataDeliveryInformation?.deliveryFee || 0 : 0;

  // Hàm xác định typeAction dựa trên userAuth và isLimit
  const determineTypeAction = (userAuth: any, isLimit: boolean): number => {
    // Trường hợp 1: userAuth = 1 và isLimit = false thì gán = 2 (duyệt)
    if (userAuth?.typeAtuh === 1 && !isLimit) {
      return 2; // duyệt
    }

    // Trường hợp 2: userAuth = 1 và isLimit = true thì gán = 1 (trình)
    if (userAuth?.typeAtuh === 1 && isLimit) {
      return 1; // trình
    }

    // Trường hợp 3: userAuth = 2 thì không cần check isLimit và gán luôn = 2
    if (userAuth?.typeAtuh === 2) {
      return 2; // duyệt
    }

    // Mặc định trả về 1 (trình) cho các trường hợp khác
    return 1;
  };

  //#region handle FUNC

  const handleAllocateItems = async () => {
    try {
      const requestBody = {
        priceKm: orderHeader?.amountDiscountTotal || 0, //  Khuyến mãi tổng đơn, cập nhật giá trị nếu cần
        priceReduce: orderHeader?.discountAddedTotal || 0,
        idItems: listAdd.map((item: any) => ({
          price: item.priceFinal || 0,
          itemId: item.itemId || 0,
          quantity: item.quality || 0,
          itemCode: item.itemCode || "",
        })),
      };

      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblItem/get-allcation-item`,
        requestBody,
      );

      if (response && response.success) {
        // const data = response.data;
        // // Tính tổng priceAllKM và priceAll từ data
        // const totalPriceAllKM = data?.reduce(
        //   (sum: number, item: any) => sum + (item.priceAllKM || 0),
        //   0
        // );
        // const totalPriceAll = data?.reduce(
        //   (sum: number, item: any) => sum + (item.priceAll || 0),
        //   0
        // );

        // // Lấy giá trị từ orderHeader
        // const expectedPriceAllKM = orderHeader?.amountDiscountTotal || 0;
        // const expectedPriceAll = orderHeader?.discountAddedTotal || 0;

        // // Kiểm tra điều kiện hợp lệ
        // if (expectedPriceAllKM > 0 && totalPriceAllKM !== expectedPriceAllKM) {
        //   NotificationExtension.Fails(
        //     `Lỗi: Tổng priceAllKM (${totalPriceAllKM}) không khớp với amountDiscountTotal (${expectedPriceAllKM})`
        //   );
        //   return;
        // }

        // if (expectedPriceAll > 0 && totalPriceAll !== expectedPriceAll) {
        //   NotificationExtension.Fails(
        //     `Lỗi: Tổng priceAll (${totalPriceAll}) không khớp với discountAddedTotal (${expectedPriceAll})`
        //   );
        //   return;
        // }
        // Xử lý logic khi API trả về thành công
        setDataAllocate(response?.data);
        setIsDisablePhanBo(true);
      } else {
        // Xử lý khi API trả về nhưng không thành công
      }
    } catch (error) {
      console.error("Error allocating items:", error);
    }
  };

  // Check if need to call discount decision support API
  React.useEffect(() => {
    const checkDiscountDecisionSupport = async () => {
      if (
        location?.state?.actionType === "approved" &&
        orderStatus === "DON_HANG_CHO_DUYET_GIAM" &&
        customerCheck?.id &&
        listAdd.length > 0
      ) {
        try {
          const itemCodes = listAdd.map((item) => item.itemCode);
          const result = await getDiscountDecisionSupportTableWholesale(
            customerCheck.id.toString(),
            itemCodes,
          );
          console.log("Discount Decision Support Data:", result);
        } catch (error) {
          console.error(
            "Error calling getDiscountDecisionSupportTable:",
            error,
          );
        }
      }
    };

    checkDiscountDecisionSupport();
  }, [location?.state?.actionType, orderStatus, customerCheck?.id, listAdd]);

  //#region handle FUNC

  console.log("discountSuggestionData", discountSuggestionData);

  // Helper function để fetch discount data khi cần thiết
  const fetchDiscountDataIfNeeded = async (): Promise<any> => {
    // Nếu đã có data thì return luôn
    if (discountSuggestionData && discountSuggestionData.customerGroup) {
      return discountSuggestionData;
    }

    // Nếu chưa có thì fetch
    if (!customerCheck?.code || listAdd.length === 0) {
      console.warn(
        "Không thể fetch discount data: thiếu thông tin khách hàng hoặc sản phẩm",
      );
      return null;
    }

    try {
      const itemCodes = listAdd.map((item) => item.itemCode);
      const result = await getDiscountDecisionSupportTableWholesale(
        customerCheck.id.toString(),
        itemCodes,
      );

      // Cập nhật state với data vừa fetch được
      setDiscountSuggestionData(result);

      return result;
    } catch (error) {
      console.error("Error fetching discount data:", error);
      return null;
    }
  };

  // Hàm xử lý mở modal gợi ý chiết khấu
  const handleOpenDiscountSuggestion = async (e: any) => {
    if (!customerCheck?.code || listAdd.length === 0) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng hoặc sản phẩm!");
      return;
    }

    setDiscountLoading(true);
    setDiscountModalOpened(true);

    try {
      const itemCodes = listAdd.map((item) => item.itemCode);
      const result = await getDiscountDecisionSupportTableWholesale(
        customerCheck.id.toString(),
        itemCodes,
      );
      setDiscountSuggestionData(result);
    } catch (error) {
      console.error("Error fetching discount suggestions:", error);
      NotificationExtension.Fails("Lỗi khi tải gợi ý chiết khấu!");
    } finally {
      setDiscountLoading(false);
    }
  };

  // Hàm xử lý mở modal chọn mức giảm giá cho từng sản phẩm
  const handleOpenDiscountSelection = async (row: any) => {
    console.log("row", row?.original?.itemCode);
    console.log("suggestionData", discountSuggestionData);

    setSelectedRowForDiscount(row);

    // Kiểm tra nếu chưa có discountSuggestionData thì gọi API trước
    let currentDiscountData = discountSuggestionData;

    if (!currentDiscountData && customerCheck?.id && listAdd.length > 0) {
      try {
        const itemCodes = listAdd.map((item) => item.itemCode);
        const result = await getDiscountDecisionSupportTableWholesale(
          customerCheck.id.toString(),
          itemCodes,
        );
        currentDiscountData = result;
        setDiscountSuggestionData(currentDiscountData);
      } catch (error) {
        console.error("Error fetching discount suggestions:", error);
        NotificationExtension.Fails("Lỗi khi tải gợi ý chiết khấu!");
        return;
      }
    }

    // Tìm discount options cho sản phẩm từ discountSuggestionData
    const itemCode = row?.original?.itemCode;
    let discountOptions = [
      { id: 1, label: "Giảm giá 1", value: 0 },
      { id: 2, label: "Giảm giá 2", value: 0 },
      { id: 3, label: "Giảm giá 3", value: 0 },
    ];

    if (currentDiscountData && currentDiscountData.itemPrices) {
      const itemData = currentDiscountData.itemPrices.find(
        (item: any) => item.itemCode === itemCode,
      );

      console.log("Found itemData for", itemCode, ":", itemData);

      if (itemData) {
        discountOptions = [
          { id: 1, label: "Giảm giá 1", value: itemData.discountPrice1 || 0 },
          { id: 2, label: "Giảm giá 2", value: itemData.discountPrice2 || 0 },
          { id: 3, label: "Giảm giá 3", value: itemData.discountPrice3 || 0 },
        ];
        console.log("Updated discountOptions:", discountOptions);
      }
    }

    console.log("Final discountOptions before setting:", discountOptions);
    setCurrentDiscountOptions(discountOptions);

    // Đặt timeout ngắn để đảm bảo state đã được cập nhật trước khi mở modal
    setTimeout(() => {
      setDiscountSelectionOpened(true);
    }, 50);
  };

  // Hàm xử lý khi chọn mức giảm giá
  const handleSelectDiscount = (discount: number) => {
    if (selectedRowForDiscount) {
      handleChangeRequestReduction(
        discount,
        selectedRowForDiscount.original.id,
        selectedRowForDiscount.original.priceOnPriceList,
      );
      setDiscountSelectionOpened(false);
      setSelectedRowForDiscount(null);
    }
  };

  const handleRenderOptionListAdd = (
    listAdd: any[],
  ): { value: string; label: string }[] => {
    return listAdd
      .filter((item) => item.lineTyle === "HT" && item.attribute13)
      .map((item) => ({
        value: item.attribute13,
        label: item.attribute13,
      }));
  };

  const handleApprovedSalesOrder = async (noteValue?: string) => {
    if (!orderHeader.custId) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng !");
      return;
    }

    try {
      // Lấy thông tin userAuth trước khi xử lý
      let currentUserAuth = userAuth;
      if (!currentUserAuth || !currentUserAuth.typeAtuh) {
        try {
          const authData = await apiAuth.getUserAuth();
          currentUserAuth = authData?.data;
          setUserAuth(currentUserAuth);
        } catch (error) {
          console.error("Error fetching user auth:", error);
          NotificationExtension.Fails(
            "Lỗi khi lấy thông tin quyền người dùng!",
          );
          return;
        }
      }

      // Kiểm tra mức giảm giá để xác định isLimit
      let isLimit = false;

      if (discountSuggestionData && discountSuggestionData.itemPrices) {
        // Kiểm tra từng item trong listAdd
        for (const item of listAdd) {
          // Tìm thông tin discount cho item này từ discountSuggestionData
          const itemDiscountInfo = discountSuggestionData.itemPrices.find(
            (discountItem: any) => discountItem.itemCode === item.itemCode,
          );

          if (itemDiscountInfo) {
            const discountPrice3 = itemDiscountInfo.discountPrice3 || 0;
            const currentDiscountAdded = item.discountAdded || 0;

            // Chuyển đổi discountPrice3 thành giá trị dương để so sánh
            const maxAllowedDiscount = Math.abs(discountPrice3);

            // Nếu có ít nhất 1 item có mức giảm > mức 3 (so sánh với giá trị tuyệt đối) thì isLimit = true
            if (currentDiscountAdded > maxAllowedDiscount) {
              isLimit = true;
              break; // Thoát khỏi vòng lặp vì đã tìm thấy
            }
          }
        }
      }

      // Xác định typeAction dựa trên userAuth và isLimit
      const typeAction = determineTypeAction(currentUserAuth, isLimit);

      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/approve-order-v3", {
        orderId: orderHeader.id || 0,
        type_History: 2, // 2 = duyệt giá bán wholesale
        price_b: totalAmount, // Tổng tiền trước khi sửa
        price_a: payableAmount, // Tổng tiền sau khi sửa
        isLimit: isLimit,
        typeAction: typeAction,
        note: noteValue || "", // Thêm trường note
        approves: listAdd.map((item) => ({
          id: item.id || 0,
          totalAmount: (item.priceFinal || 0) * (item.quality || 1),
          discountAdded: item.discountAdded || 0,
          priceFinal: item.priceFinal || 0,
          price: item.priceOnPriceList || 0, // Giá gốc trước khi giảm
        })),
      });

      if (response && response.success) {
        // Chỉ đổi status khi typeAction = 2 (duyệt), không đổi khi typeAction = 1 (trình)
        if (typeAction === 2) {
          setOrderStatus("DON_HANG_DA_DUYET_GIAM");
        }

        // Hiển thị thông báo phù hợp dựa trên typeAction
        if (typeAction === 1) {
          NotificationExtension.Success("Gửi trình duyệt thành công!");
        } else if (typeAction === 2) {
          NotificationExtension.Success("Duyệt giá bán thành công!");
        } else {
          NotificationExtension.Success("Xử lý thành công!");
        }

        SocketExtension.SendMessageToTopic<any>({
          topic: CREATEORDERSUCCESS,
          data: "",
        });
      } else {
        NotificationExtension.Fails(response?.message);
      }
    } catch (error) {
      console.error("Error approving sales order:", error);
      NotificationExtension.Fails("Lỗi khi duyệt đơn hàng!");
    }
  };

  // Hàm mở popup duyệt giảm với ghi chú
  const handleOpenApprovalWithNote = () => {
    let approvalNote = "";

    modals.openConfirmModal({
      title: (
        <Title order={4} style={{ color: "#1976d2" }}>
          Duyệt giảm giá
        </Title>
      ),
      size: "md",
      centered: true,
      children: (
        <Box p="md">
          <Text size="sm" mb="sm" c="red" fw={500}>
            Vui lòng nhập ghi chú cho việc duyệt giảm giá đơn hàng này (bắt
            buộc):
          </Text>
          <Textarea
            placeholder="Vui lòng nhập ghi chú duyệt giảm giá..."
            onChange={(event) => {
              approvalNote = event.currentTarget.value.trim();
            }}
            minRows={3}
            maxRows={6}
            autosize
            required
          />
        </Box>
      ),
      labels: { confirm: "Xác nhận duyệt", cancel: "Hủy" },
      confirmProps: { color: "cyan" },
      onConfirm: () => {
        if (!approvalNote || approvalNote.trim() === "") {
          NotificationExtension.Warn("Vui lòng nhập ghi chú duyệt giảm giá!");
          return false;
        }
        handleApprovedSalesOrder(approvalNote);
      },
    });
  };

  const handleChangeQuantity = (e: any, row: any) => {
    handleQuantityChange(e, row, branchId, location, setListAdd);
  };

  // Hàm mở modal theo loại
  const handleOpenModal = (type: string) => {
    setModalType(type);
  };

  // Hàm đóng modal
  const handleCloseModal = () => {
    setModalType("");
  };

  // Hàm xử lý lưu thông tin trả góp
  const handleSaveInstallment = () => {
    console.log("Thông tin trả góp:", installmentInfo);
    handleCloseModal();
  };

  // Hàm xử lý lưu thông tin công nợ
  const handleSaveDebt = () => {
    console.log("Thông tin công nợ:", debtInfo);
    handleCloseModal();
  };

  const handleChangePrice = (value: any, key: string) => {
    handlePaymentChange(key, value, {
      setCashPayment,
      setBankTransfer,
      setCardPayment,
      setVnpayPayment,
      setAnotherPayment,
    });
  };

  const handleChooseCustomer = (value: any, isChooseCustomer: any) => {
    if (isChooseCustomer) {
      // Chỉ cập nhật attribute1 nếu isChooseCustomer = true
      setCustomerCheck({
        ...customerCheck,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        attribute1: value?.attribute1,
      });
    } else {
      // Cập nhật toàn bộ thông tin khách hàng
      setCustomerCheck({
        ...customerCheck,
        code: value?.code,
        name: value?.name,
        telephoneNumber: value?.telephoneNumber,
        id: value?.id,
        type: value?.type,
        province: value?.province,
        district: value?.district,
        commune: value?.commune,
        address: value?.address,
        attribute1: value?.attribute1,
        attribute4: value?.attribute4,
        companyName: value?.companyName,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        groupId: value?.groupId,
        taxCode: value?.taxCode,
        email: value?.email,
      });

      setOrderHeader({ ...orderHeader, custId: value?.id });

      // Kiểm tra nếu listBuyerName có phần tử hợp lệ thì cập nhật state
      if (
        Array.isArray(value?.listBuyerName) &&
        value.listBuyerName.length > 0
      ) {
        const filteredBuyerNames = value.listBuyerName
          .map((buyer: any) => {
            const parts = [];

            if (buyer.name) parts.push(buyer.name);
            if (buyer.telephoneNumber) parts.push(buyer.telephoneNumber);
            if (buyer.attribute1) parts.push(buyer.attribute1);

            return parts.length > 0 ? parts.join(" - ") : null;
          })
          .filter(Boolean); // Loại bỏ giá trị null, undefined, ""

        setListBuyerName(filteredBuyerNames);

        setListAddress(value?.listAddress || []); // Cập nhật listAddress nếu có
        setDataDeliveryInformation((prev: any) => ({
          ...prev,
          listAddress: value?.listAddress || [],
        }));
        // Auto chọn phần tử đầu tiên của mảng listBuyerName làm người mua hàng
        setOrderHeader((prev) => ({
          ...prev,
          attribute36: filteredBuyerNames[0] || "",
        }));
      } else {
        setListBuyerName([]); // Nếu không có dữ liệu hợp lệ, đặt về mảng rỗng
        setListAddress([]); // Cập nhật listAddress nếu có
        setDataDeliveryInformation((prev: any) => ({
          ...prev,
          listAddress: [],
        }));
        setOrderHeader((prev) => ({
          ...prev,
          attribute36: "",
        }));
      }
    }
  };

  // Hàm nhận vào payType và trả về payAmount
  const getPayAmountByPayType = (payType: string): number | undefined => {
    const payment = dataPayment?.find((p: any) => p.PayType === payType);
    return payment ? payment?.PayAmount : undefined;
  };

  const getCardBank = () => {
    const bankCard = dataPayment?.find((p: any) => p.PayType === "03");
    return bankCard ? bankCard?.Attribute1 : undefined;
  };

  const headerRef = React.useRef<HTMLDivElement>(null);

  const handleSelectProduct = async (
    product: ProductModel,
    index: number,
    modeSearch?: string,
  ) => {
    try {
      if (branchId) {
        const callapiPromotion = await repositoryPos.post<
          MessageResponse<TblItemPromotionModel[]>
        >(`/api/v1/TblItem/item-promotion`, {
          id: product.id,
          price: product?.price || 0,
          branch: branchId,
        });

        const discountRate =
          (callapiPromotion?.data &&
            callapiPromotion?.data.length > 0 &&
            callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
              ?.discountPercent) ||
          0;
        const discountAmount =
          (callapiPromotion?.data &&
            callapiPromotion?.data.length > 0 &&
            callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
              ?.discountAmount) ||
          0;

        // Lấy giá bán theo customerGroup từ discount suggestion data nếu có
        let finalPrice = product?.price || 0;
        let priceType = "Giá niêm yết";

        // Tự động gọi API nếu chưa có discountSuggestionData nhưng có thông tin khách hàng
        if (customerCheck?.id && !discountSuggestionData) {
          try {
            const result = await getDiscountDecisionSupportTableWholesale(
              customerCheck.id.toString(),
              [product.productCode],
            );
            setDiscountSuggestionData(result);

            // Áp dụng giá ngay sau khi có dữ liệu
            if (result?.itemPrices && result?.customerGroup) {
              const itemData = result.itemPrices.find(
                (item: any) => item.itemCode === product.productCode,
              );

              if (itemData) {
                const customerGroup = result.customerGroup;

                if (customerGroup === 1 && itemData.discountPrice1 > 0) {
                  finalPrice = itemData.discountPrice1;
                  priceType = "Giá buôn 1";
                } else if (customerGroup === 2 && itemData.discountPrice2 > 0) {
                  finalPrice = itemData.discountPrice2;
                  priceType = "Giá buôn 2";
                } else if (customerGroup === 3 && itemData.discountPrice3 > 0) {
                  finalPrice = itemData.discountPrice3;
                  priceType = "Giá buôn 3";
                }
              }
            }
          } catch (error) {
            console.error("Error fetching discount suggestion data:", error);
          }
        }
        // Nếu đã có discountSuggestionData thì sử dụng như bình thường
        else if (customerCheck?.code && discountSuggestionData?.itemPrices) {
          const itemData = discountSuggestionData.itemPrices.find(
            (item: any) => item.itemCode === product.productCode,
          );

          if (itemData && discountSuggestionData.customerGroup) {
            const customerGroup = discountSuggestionData.customerGroup;

            // Áp dụng giá theo customerGroup
            if (customerGroup === 1 && itemData.discountPrice1 > 0) {
              finalPrice = itemData.discountPrice1;
              priceType = "Giá buôn 1";
            } else if (customerGroup === 2 && itemData.discountPrice2 > 0) {
              finalPrice = itemData.discountPrice2;
              priceType = "Giá buôn 2";
            } else if (customerGroup === 3 && itemData.discountPrice3 > 0) {
              finalPrice = itemData.discountPrice3;
              priceType = "Giá buôn 3";
            }
          }
        }

        let idPromote = 0;
        let idPromoteHT = 0;

        if (callapiPromotion?.data) {
          idPromote =
            callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]?.id || 0;
          idPromoteHT =
            callapiPromotion?.data[0]?.tblPromotionItemGift[0]?.id || 0;
        }

        // Xử lý bốn loại giá
        const priceOptions = JSON.stringify({
          retailPrice: product?.price || 0, // Giá bán lẻ
          wholesalePrice1: product?.price1 || 0, // Giá buôn 1
          wholesalePrice2: product?.price2 || 0, // Giá buôn 2
          wholesalePrice3: product?.price3 || 0, // Giá buôn 3
        });

        const addData: dataOrderDetailTable = {
          attribute23: product?.wareHouseCode,
          attribute20: product?.warranty?.toString(),
          id: product?.id,
          itemCode: product?.productCode,
          itemName: product?.productName,
          primaryUomCode: product?.unit || "",
          orgId: product?.warehouseId || 0,
          warehouse: product?.warehouse || "",
          priceType: priceType,
          quality: product?.quantity || 1,
          discountRate: discountRate,
          discountAmount: discountAmount,
          discountAdded: 0,
          priceFinal: discountRate
            ? finalPrice * 1 * (1 - discountRate / 100)
            : finalPrice * 1 - (discountAmount || 0) || 0,
          vatRate: 0,
          vatAmount: 0,
          totalLineAmount: discountRate
            ? finalPrice * 1 * (1 - discountRate / 100)
            : finalPrice * 1 - (discountAmount || 0) || 0,
          note: product?.notes ?? "",
          lineTyle: modeSearch === "DV" ? "DV" : "HH",
          orderHeaderId: 0,
          deptId: 0,
          itemId: product?.id,
          linkToItemId: 0,
          uomCode: "",
          priceListId: 0,
          priceOnPriceList: finalPrice,
          idPromote: idPromote || 0,
          idPromoteList: "",
          linkToLineId: 0,
          printInvoiceCheck: 0,
          promotePostPaid: "",
          promoteClearCheck: 0,
          promoteClearDate: "",
          prometeClearPersionId: 0,
          prometeClearClientId: "",
          clientId: 0,
          workShiftId: 0,
          createBy: 0,
          createDate: "",
          lastUpdateBy: 0,
          lastUpdateDate: "",
          subInvId: product?.warehouseId || 0,
          listIdPromotion: [
            callapiPromotion?.data &&
            callapiPromotion.data.length > 0 &&
            typeof callapiPromotion.data[0].tblPromotion.id === "number"
              ? callapiPromotion.data[0].tblPromotion.id
              : null,
          ].filter((id): id is number => id !== null),
          listIdAddOn: [],
          listIdGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map(
                (item) => item.idItemGift,
              )) ||
            [],
          promotionDiscountPercent:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountPercent) ||
            0,
          promotionDiscountAmount:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountAmount) ||
            0,
          promotionItemGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map((item) => ({
                itemCode: item?.itemForSellModel.productCode,
                itemName: item?.itemForSellModel.productName,
                primaryUomCode: item?.itemForSellModel.unit || "",
                quality: 1,
                warehouse: item?.itemForSellModel.warehouse,
              }))) ||
            [],
          attribute18: priceOptions, // Lưu chuỗi JSON vào attribute18
          coBanLe: product?.coBanLe,
          hasPromotion: Boolean(
            callapiPromotion?.data && callapiPromotion.data.length > 0
          ),
        };

        if (
          callapiPromotion?.data &&
          callapiPromotion?.data[0]?.tblPromotionItemGift?.length > 0
        ) {
          setListAdd((prevList) => {
            // Nếu index === -1, thêm addData vào đầu mảng
            if (index === -1) {
              return [addData, ...prevList]; // Thêm addData vào đầu, và dataItemGif vào cuối
            } else {
              // Nếu index khác -1, cập nhật phần tử tại vị trí index và thêm dataItemGif
              const newList = [...prevList];
              newList[index] = addData;
              return newList;
            }
          });
          return;
        }

        setListAdd((prevList) => {
          if (index === -1) {
            return [addData, ...prevList];
          } else {
            const newList = [...prevList];
            newList[index] = addData;
            return newList;
          }
        });

        setIsCreating(false);
        table.setEditingRow(null);
        setDataProducts([]);
      }
    } catch (error) {
      console.error("Error in handleSelectProduct:", error);
    }
  };

  const handleGetNameAccountantById = async (
    accountantId: number | undefined,
  ) => {
    try {
      if (accountantId && accountantId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${accountantId}`,
        );
        if (response && response.success) {
          setAccountantName(response?.data?.fullName);
        }
      }
    } catch (error) {
      console.error("Error fetching accountant name:", error);
      return ""; // Trả về chuỗi rỗng nếu có lỗi
    }
  };
  const handleSelectShipingVendor = (value: any) => {
    setShipingVendor(value?.DoiTacVanChuyen);
  };

  const handleSelectPromotionMain = (promotionMain: any) => {
    if (!promotionMain) return;
    const updatedList = listAdd.map((item) => {
      // Kiểm tra nếu itemId trùng với idItemPrimary
      if (
        item?.itemId ===
        promotionMain?.tblPromotionItemPrimary[0]?.idItemPrimary
      ) {
        const discountPrice =
          promotionMain?.tblPromotionItemPrimary[0]?.discountPrice || 0;
        const discountRate =
          promotionMain?.tblPromotionItemPrimary[0]?.discountPercent || 0;
        const promoId =
          promotionMain?.tblPromotion?.id ||
          promotionMain?.tblPromotionItemPrimary[0]?.id ||
          0;

        // Nếu có discountPrice > 0 thì sử dụng logic mới
        if (discountPrice > 0) {
          const discountAmt = (item?.priceOnPriceList || 0) - discountPrice;
          return {
            ...item,
            idPromote: promotionMain?.tblPromotionItemPrimary[0]?.id,
            discountAmount: discountAmt,
            discountRate: discountRate,
            priceFinal: discountPrice,
            totalLineAmount: discountPrice * (item.quality || 1),
            // Thêm thông tin voucher vào item để dễ console log
            voucherInfo: promotionMain,
            listIdPromotion: [promoId].filter(Boolean),
            promotionDiscountPercent: discountRate,
            promotionDiscountAmount: discountAmt,
            hasPromotion: true,
          };
        } else {
          // Giữ nguyên logic cũ khi không có discountPrice hoặc discountPrice <= 0
          const discountAmt =
            promotionMain?.tblPromotionItemPrimary[0]?.discountAmount || 0;
          const finalPrice = discountRate
            ? item?.priceOnPriceList *
                1 *
                (1 - discountRate / 100) -
              (item?.discountAdded || 0)
            : item?.priceOnPriceList * 1 -
                discountAmt -
                (item?.discountAdded || 0) || 0;

          return {
            ...item,
            idPromote: promotionMain?.tblPromotionItemPrimary[0]?.id,
            discountAmount: discountAmt,
            discountRate: discountRate,
            priceFinal: finalPrice,
            totalLineAmount: finalPrice * (item.quality || 1),
            // Thêm thông tin voucher vào item để dễ console log
            voucherInfo: promotionMain,
            listIdPromotion: [promoId].filter(Boolean),
            promotionDiscountPercent: discountRate,
            promotionDiscountAmount: discountAmt,
            hasPromotion: true,
          };
        }
      }
      return item; // Trả về item không thay đổi nếu không khớp
    });
    setListAdd(updatedList);
  };

  const handleSelectProductAddOn = async (
    products: itemAddOnPromotionModel[],
    itemId: string,
  ) => {
    try {
      if (branchId) {
        const newAddDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemAddOn}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemAddOn || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: product.discountPercent || 0,
              discountAmount: product.discountAmount || 0,
              discountAdded: 0,
              priceFinal: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              note: "",
              lineTyle: "HK",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemAddOn || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };

            newAddDataList.push(addData);
          }
        }

        setListAdd((prevList) => [...prevList, ...newAddDataList]);
        table.setEditingRow(null);
      }
    } catch (error) {
      console.error("Error in handleSelectProductAddOn:", error);
    }
  };

  const debouncedNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        note: value,
      })),
    300, // Độ trễ 300ms
  );

  const debouncedCashierNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        attribute23: value,
      })),
    300,
  );

  const handleSelectProductGift = async (
    products: itemGiftPromotionModel[],
    itemId: string,
  ) => {
    try {
      if (branchId) {
        const addDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemGift}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemGift || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: 100,
              discountAmount: 0,
              discountAdded: 0,
              priceFinal: 0,
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: 0,
              note: "",
              lineTyle: "KM",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemGift || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };
            addDataList.push(addData);
          }
        }

        setListAdd((prevList) => [...prevList, ...addDataList]);
      }
    } catch (error) {
      console.error("Error in handleSelectProductGift:", error);
    }
  };

  // Hàm bỏ chọn CTKM - reset giá về giá bán buôn, gỡ toàn bộ mã CTKM, xóa quà tặng/mua kèm liên quan
  const handleRemovePromotion = (itemId: string) => {
    setListAdd((prevList) => {
      // Tìm sản phẩm chính để lấy thông tin quà tặng (nếu có)
      const targetItem = prevList.find(
        (item) =>
          String(item.itemId) === String(itemId) ||
          String(item.id) === String(itemId)
      );
      const giftIds = targetItem?.listIdGift || [];

      // Reset toàn bộ thông tin khuyến mãi cho sản phẩm chính
      const updatedList = prevList.map((item) => {
        if (
          String(item.itemId) === String(itemId) ||
          String(item.id) === String(itemId)
        ) {
          return {
            ...item,
            idPromote: 0,
            idPromoteList: "",
            discountAmount: 0,
            discountRate: 0,
            priceFinal: item.priceOnPriceList,
            totalLineAmount: (item.priceOnPriceList || 0) * (item.quality || 1),
            voucherInfo: null,
            promotionDiscountPercent: 0,
            promotionDiscountAmount: 0,
            promotionItemGift: [],
            listIdGift: [],
            listIdAddOn: [],
            listIdPromotion: [],
            hasPromotion: true,
          };
        }
        return item;
      });

      // Xóa tất cả các dòng quà tặng (KM) và mua kèm (HK) liên quan tới sản phẩm này
      const filteredList = updatedList.filter((item) => {
        if (
          (item.lineTyle === "KM" || item.lineTyle === "HK") &&
          (String(item.linkToItemId) === String(itemId) ||
            (targetItem &&
              String(item.linkToItemId) === String(targetItem.id)) ||
            (targetItem &&
              String(item.linkToItemId) === String(targetItem.itemId)) ||
            giftIds.includes(item.id) ||
            giftIds.includes(item.itemId))
        ) {
          return false; // Xóa dòng quà tặng/mua kèm liên quan
        }
        return true;
      });

      return filteredList;
    });
  };

  function openFormShipDepartment() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin bộ phận giao vận</Title>
        </>
      ),
      size: "400px",
      children: <ChooseShipDepartment onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const handleCallApiPayment = async () => {
    try {
      const expectedPriceAllKM = orderHeader?.amountDiscountTotal || 0;
      const expectedPriceAll = orderHeader?.discountAddedTotal || 0;
      if (
        (expectedPriceAllKM > 0 || expectedPriceAll > 0) &&
        dataAllocate.length === 0
      ) {
        NotificationExtension.Fails("Vui lòng phân bổ trước khi thanh toán !");
        return;
      }
      // Tạo mảng paymentCommands
      const paymentCommands = [
        {
          // Tiền mặt
          payType: "02",
          payAmount: cashPayment,
          payeeId: customerCheck?.id,
        },
        {
          // QR MB
          payType: "01",
          payAmount: bankTransfer,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve
            ? transactionCodeReserve
            : transactionCodeMb,
        },
        {
          // VN pay
          payType: "04",
          payAmount: vnpayPayment,
          payeeId: customerCheck?.id,
        },
        {
          // Cà thẻ
          payType: "03",
          payAmount: cardPayment,
          payeeId: customerCheck?.id,
          attribute1: selectedBank, // Ngân hàng cà thẻ
        },
        {
          // Thanh toán khác
          payType: "08",
          payAmount: anotherPayment,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve,
        },
      ].filter((payment) => payment.payAmount > 0); // Lọc các phương thức thanh toán có payAmount > 0
      const combinedInfo = {
        payLaterMethod,
        installmentInfo:
          payLaterMethod === "Trả góp" ? installmentInfo : undefined,
        debtInfo: payLaterMethod === "Công nợ" ? debtInfo : undefined,
      };

      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/payment", {
        paymentCommands: paymentCommands,
        orderNumber: orderHeader?.orderNumber,
        attribute20: JSON.stringify(combinedInfo),
        attribute1: selectedBankReserve,
        attribute2: transactionCodeReserve,
        attribute23: orderHeader?.attribute23 || "",
        tblOrderDetails: dataAllocate?.length > 0 ? listAdd : [],
        orderTotal: payableAmount,
      });

      if (response?.success) {
        setOrderStatus("DON_HANG_HOAN_THANH");
        NotificationExtension.Success("Hoàn tất thanh toán thành công");
        // setIsPrinting(true);
        // setIdPrint(location?.state.id);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    }
    modals.closeAll();
  };

  const handleDeleteOrder = async (orderNumber: string, type: string) => {
    const res = await repositoryPos.get<MessageResponse<boolean>>(
      `/api/v1/CreateSellItem/delete?orderNumber=${orderNumber}`,
    );
    if (res?.success) {
      type === "cancel"
        ? NotificationExtension.Success("Hủy thành công !")
        : NotificationExtension.Success("Từ chối duyệt thành công !");
      setOrderStatus("DON_HANG_HUY");
    } else
      type === "cancel"
        ? NotificationExtension.Fails("Hủy thất bại !")
        : NotificationExtension.Fails("Từ chối duyệt thất bại !");
    modals.closeAll();
  };

  const handleCopyItemCodes = () => {
    const itemCodes = listAdd.map((item) => item.itemCode).join("\n"); // Ghép itemCode thành chuỗi
    navigator.clipboard
      .writeText(itemCodes)
      .then(() => {
        NotificationExtension.Success("Đã sao chép mã đơn hàng!");
      })
      .catch((err) => console.error("Lỗi sao chép:", err));
  };

  const handleClickCancelSalesOrder = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xác nhận hủy đơn hàng !</Title>
        </>
      ),

      size: "xs",
      children: (
        <Flex justify={"end"} gap={20} mt={"sm"}>
          <Button
            color="gray"
            leftSection={<IconWindow size={18} />}
            onClick={() => {
              modals.closeAll();
            }}
          >
            Huỷ
          </Button>
          <Button
            leftSection={<IconCheck size={18} />}
            onClick={() => {
              handleDeleteOrder(orderHeader?.orderNumber, "cancel");
              navigate("/sell/sales-order-list");
              modals.closeAll();
            }}
          >
            Xác nhận
          </Button>
        </Flex>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  function openFormShipCompany() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin đối tác giao vận</Title>
        </>
      ),
      size: "70vw",
      children: <ShipCompanyTable onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  // Hàm validate kiểm tra giá bán so với giá buôn 3 khi chốt đơn
  const validateWholesalePricing = (): boolean => {
    let isLimit = false;

    // Kiểm tra từng item trong listAdd
    for (const item of listAdd) {
      try {
        // Parse giá buôn từ attribute18 (JSON string)
        if (item.attribute18) {
          const priceOptions = JSON.parse(item.attribute18);
          const wholesalePrice3 = priceOptions.wholesalePrice3 || 0;
          const currentPrice = item.priceOnPriceList || 0;

          // Nếu có ít nhất 1 item có giá bán < giá buôn 3 thì isLimit = true
          if (currentPrice < wholesalePrice3 && wholesalePrice3 > 0) {
            console.log(
              `Item ${item.itemCode}: Giá bán (${currentPrice}) < Giá buôn 3 (${wholesalePrice3})`,
            );
            isLimit = true;
            break; // Thoát khỏi vòng lặp vì đã tìm thấy
          }
        }
      } catch (error) {
        console.error(
          `Error parsing price options for item ${item.itemCode}:`,
          error,
        );
        // Nếu có lỗi parse JSON, tiếp tục với item tiếp theo
        continue;
      }
    }

    return isLimit;
  };

  const handleCreateSalesOrder = useDebouncedCallback(
    async (isLock: boolean) => {
      // Validate thông tin xuất hóa đơn VAT khi Có xuất VAT hoặc Nợ VAT
      if (orderHeader?.printInvoiceCheck === 1) {
        if (
          !taxInfo.TaxCode ||
          !taxInfo.TaxCompany ||
          !taxInfo.TaxEmail ||
          !taxInfo.TaxAddress
        ) {
          NotificationExtension.Warn(
            "Vui lòng nhập đầy đủ thông tin xuất hóa đơn VAT: Mã số thuế, Tên công ty, Email nhận hóa đơn và Địa chỉ công ty",
          );
          return;
        }

        if (emailError) {
          NotificationExtension.Warn(
            "Email nhận hóa đơn không đúng định dạng. Vui lòng kiểm tra lại!",
          );
          return;
        }
      }

      // Hiển thị loading ngay từ đầu
      openLoading();

      try {
        // Fetch discount data để lấy customerGroup cho attribute70
        let currentDiscountSuggestionData: any = null;
        if (customerCheck?.code) {
          currentDiscountSuggestionData = await fetchDiscountDataIfNeeded();
        } else {
          currentDiscountSuggestionData = discountSuggestionData;
        }

        // Validate giá buôn khi chốt đơn và lưu kết quả vào biến
        const isLimit = validateWholesalePricing();

        if (isLock && isLimit) {
          closeLoading(); // Tắt loading khi hiện modal
          let noteValue = "";
          const confirmResult = await new Promise((resolve) => {
            modals.openConfirmModal({
              title: "Cảnh báo giá bán",
              size: "lg",
              centered: true,
              children: (
                <Box>
                  <Text size="md" fw={500} mb="md">
                    Có sản phẩm có giá bán thấp hơn giá buôn mức 3. Bạn có chắc
                    chắn muốn gửi duyệt không?
                  </Text>
                  <Text size="sm" mb="sm" c="red" fw={500}>
                    Nhập ghi chú duyệt giảm giá (bắt buộc):
                  </Text>
                  <Textarea
                    placeholder="Vui lòng nhập ghi chú duyệt giảm giá..."
                    onChange={(event) => {
                      noteValue = event.currentTarget.value.trim();
                    }}
                    minRows={3}
                    maxRows={6}
                    autosize
                    required
                  />
                </Box>
              ),
              labels: { confirm: "Xác nhận", cancel: "Hủy" },
              onCancel: () => resolve(false),
              onConfirm: () => {
                if (!noteValue || noteValue.trim() === "") {
                  NotificationExtension.Warn(
                    "Vui lòng nhập ghi chú duyệt giảm giá!",
                  );
                  return false;
                }
                resolve(true);
              },
            });
          });

          if (!confirmResult) {
            return; // Dừng lại nếu user không xác nhận
          }

          openLoading(); // Bật lại loading sau khi confirm

          // Không lưu ghi chú duyệt giảm giá vào orderHeader.note
          // vì nó sẽ được gửi trực tiếp qua API trong phần tạo đơn hàng
        }

        if (
          !handleCheckIsSuccessValidateItem(listAdd) &&
          location?.state?.actionType === "doi"
        ) {
          NotificationExtension.Warn(
            "Vui lòng điền trường hợp đổi , Serial đổi !",
          );
          closeLoading();
          return;
        }
        const isShippingRequired = shipping !== "Nhận tại cửa hàng";
        const isMissingDeliveryInfo = [
          dataDeliveryInformation?.customerId,
          dataDeliveryInformation?.telephoneNumber,
          dataDeliveryInformation?.customerProvinceId,
          dataDeliveryInformation?.customerDistrictId,
          dataDeliveryInformation?.customerCommuneId,
          dataDeliveryInformation?.customerAddress,
          dataDeliveryInformation?.deliveryAppointmentTime,
          dataDeliveryInformation?.shippingVendor,
          dataDeliveryInformation?.typeShip,
        ].some((field) => !field);

        if (isShippingRequired && isMissingDeliveryInfo) {
          NotificationExtension.Warn(
            "Vui lòng điền đầy đủ thông tin giao hàng!",
          );
          closeLoading();
          return;
        }

        if (!orderHeader?.custId && !orderHeaderRef?.custId) {
          NotificationExtension.Warn("Chưa có thông tin khách hàng!");
          closeLoading();
          return;
        }

        if (
          (orderHeader?.amountDiscountTotal ?? 0) > 0 &&
          (!orderHeader?.attribute97 || !orderHeader.attribute97.trim())
        ) {
          NotificationExtension.Warn(
            "Vui lòng nhập diễn giải khuyến mãi tổng đơn!",
          );
          setPromoDescOpened(true);
          closeLoading();
          return;
        }

        let newListAdd: dataOrderDetailTable[];
        if (location?.state?.actionType === "doi") {
          newListAdd = listAdd
            .map((item) => {
              return {
                ...item,
                totalLineAmount: item.priceFinal * item.quality,
              };
            })
            .filter((i) => {
              return (
                i?.attribute11 !== "G" &&
                i?.attribute11 !== "H" &&
                i?.attribute11 !== "T"
              );
            });
        } else {
          newListAdd = listAdd.map((item) => {
            return {
              ...item,
              totalLineAmount: item.priceFinal * item.quality,
              deptId: orderHeader?.deptId,
            };
          });
        }

        // Sử dụng lại kết quả từ fetchDiscountDataIfNeeded để map vào attribute83
        // Không cần gọi API lần nữa vì đã gọi ở trên
        if (
          currentDiscountSuggestionData &&
          typeof currentDiscountSuggestionData.customerGroup !== "undefined"
        ) {
          (orderHeader as any).attribute83 = String(
            currentDiscountSuggestionData.customerGroup,
          );
        }

        const response = await repositoryPos.post<
          MessageResponse<dataCreateSalesOrder>
        >("/api/v1/CreateSellItem/create", {
          orderDetail: newListAdd,
          orderHeader: {
            ...orderHeader,
            attribute69: isLimit ? "1" : "0", // Thêm trường attribute69 để lưu trạng thái giá bán thấp hơn giá buôn 3
            shipngType: shipping,
            shipingVendor: shipingVendor,
            invOrgId: branchId ? branchId : 488,
            orgId: branchId ? branchId : 488,
            saleChanelId: saleChanelId ? saleChanelId : 67,
            saleId: employeeSalesId,
            deptId: departmentId,
            printInvoiceCheck: orderHeader?.printInvoiceCheck,
            attribute2: accountantId,
            attribute18: employeeSalesRevenueId,
            contractcode: contractcode,
            orderTypeId: 1,
            branchId: branchId ? branchId : 488,
            amountTotal: payableAmount,
            amountDiscount: totalKMLine,
            amountVat: 0,
            attribute1: JSON.stringify({
              ...dataDeliveryInformation,
              branchId: branchId,
            }),
            createDate: orderHeader?.orderDate,
            orderNumberLink: location?.state?.orderNumberOld,
            attribute8:
              customerCheck?.name && customerCheck?.code
                ? `${customerCheck.name}||${customerCheck.code}`
                : "",
            attribute16: customerCheck?.attribute1,
            attribute31: customerCheck?.attribute4,
            custId: orderHeader?.custId
              ? orderHeader?.custId
              : customerCheck?.id,
            attribute70: currentDiscountSuggestionData?.customerGroup ?? null,
          },
          isRetun: location?.state?.actionType === "doi",
          isLock: isLock,
        });
        if (response && response.success) {
          // Kiểm tra isLimit để xác định trạng thái và thông báo
          if (isLock && isLimit) {
            setOrderStatus("DON_HANG_CHO_DUYET_GIAM");
            setTimeout(
              () => NotificationExtension.Success("Gửi duyệt thành công !"),
              500,
            );
          } else {
            setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");
            const messageNoti = isLock
              ? "Chốt đơn hàng thành công !"
              : "Lưu đơn hàng thành công !";
            setTimeout(() => NotificationExtension.Success(messageNoti), 500);
          }

          SocketExtension.SendMessageToTopic<any>({
            topic: CREATEORDERSUCCESS,
            data: "",
          });
        } else {
          NotificationExtension.Fails(
            response?.message ||
              (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !"),
          );
        }
      } catch (error) {
        console.error("Error creating sales order:", error);
        NotificationExtension.Fails("Có lỗi xảy ra khi lưu đơn hàng!");
      } finally {
        closeLoading();
      }
    },
    1000,
  );

  const handleEditSalesOrder = useDebouncedCallback(async (isLock: boolean) => {
    // Validate thông tin xuất hóa đơn VAT khi Có xuất VAT hoặc Nợ VAT
    if (orderHeader?.printInvoiceCheck === 1) {
      if (
        !taxInfo.TaxCode ||
        !taxInfo.TaxCompany ||
        !taxInfo.TaxEmail ||
        !taxInfo.TaxAddress
      ) {
        NotificationExtension.Warn(
          "Vui lòng nhập đầy đủ thông tin xuất hóa đơn VAT: Mã số thuế, Tên công ty, Email nhận hóa đơn và Địa chỉ công ty",
        );
        return;
      }

      if (emailError) {
        NotificationExtension.Warn(
          "Email nhận hóa đơn không đúng định dạng. Vui lòng kiểm tra lại!",
        );
        return;
      }
    }

    // Hiển thị loading ngay từ đầu
    openLoading();

    try {
      // Fetch discount data để lấy customerGroup cho attribute70
      let currentDiscountSuggestionData: any = null;
      if (customerCheck?.code) {
        currentDiscountSuggestionData = await fetchDiscountDataIfNeeded();
      } else {
        currentDiscountSuggestionData = discountSuggestionData;
      }

      // Validate giá buôn khi chốt đơn và lưu kết quả vào biến
      const isLimit = validateWholesalePricing();

      if (isLock && isLimit) {
        closeLoading(); // Tắt loading khi hiện modal
        let noteValue = "";
        const confirmResult = await new Promise((resolve) => {
          modals.openConfirmModal({
            title: "Cảnh báo giá bán",
            size: "lg",
            centered: true,
            children: (
              <Box>
                <Text size="md" fw={500} mb="md">
                  Có sản phẩm có giá bán thấp hơn giá buôn mức 3. Bạn có chắc
                  chắn muốn gửi duyệt không?
                </Text>
                <Text size="sm" mb="sm" c="red" fw={500}>
                  Nhập ghi chú duyệt giảm giá (bắt buộc):
                </Text>
                <Textarea
                  placeholder="Vui lòng nhập ghi chú duyệt giảm giá..."
                  onChange={(event) => {
                    noteValue = event.currentTarget.value.trim();
                  }}
                  minRows={3}
                  maxRows={6}
                  autosize
                  required
                />
              </Box>
            ),
            labels: { confirm: "Xác nhận", cancel: "Hủy" },
            onCancel: () => resolve(false),
            onConfirm: () => {
              if (!noteValue || noteValue.trim() === "") {
                NotificationExtension.Warn(
                  "Vui lòng nhập ghi chú duyệt giảm giá!",
                );
                return false;
              }
              resolve(true);
            },
          });
        });

        if (!confirmResult) {
          return; // Dừng lại nếu user không xác nhận
        }

        openLoading(); // Bật lại loading sau khi confirm
      }

      const isShippingRequired = shipping !== "Nhận tại cửa hàng";
      const isMissingDeliveryInfo = [
        dataDeliveryInformation?.customerId,
        dataDeliveryInformation?.telephoneNumber,
        dataDeliveryInformation?.customerProvinceId,
        dataDeliveryInformation?.customerDistrictId,
        dataDeliveryInformation?.customerCommuneId,
        dataDeliveryInformation?.customerAddress,
        dataDeliveryInformation?.deliveryAppointmentTime,
        dataDeliveryInformation?.shippingVendor,
        dataDeliveryInformation?.typeShip,
      ].some((field) => !field);

      if (isShippingRequired && isMissingDeliveryInfo) {
        NotificationExtension.Warn("Vui lòng điền đầy đủ thông tin giao hàng!");
        closeLoading();
        return;
      }

      if (!orderHeader.custId) {
        NotificationExtension.Warn("Chưa có thông tin khách hàng!");
        closeLoading();
        return;
      }

      const newListAdd = listAdd.map((item) => {
        return {
          ...item,
          totalLineAmount: item.priceFinal * item.quality,
          deptId: orderHeader?.deptId,
        };
      });

      // Sử dụng lại kết quả từ fetchDiscountDataIfNeeded để map vào attribute83
      // Không cần gọi API lần nữa vì đã gọi ở trên
      if (
        currentDiscountSuggestionData &&
        typeof currentDiscountSuggestionData.customerGroup !== "undefined"
      ) {
        (orderHeader as any).attribute83 = String(
          currentDiscountSuggestionData.customerGroup,
        );
      }

      openLoading();
      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/edit", {
        orderDetail: newListAdd,
        orderHeader: {
          ...orderHeader,
          attribute69: isLimit ? "1" : "0", // Thêm trường attribute69 để lưu trạng thái giá bán thấp hơn giá buôn 3
          shipngType: shipping,
          shipingVendor: shipingVendor,
          invOrgId: branchId ? branchId : 488,
          orgId: branchId ? branchId : 488,
          saleChanelId: saleChanelId
            ? saleChanelId
            : orderHeader?.saleChanelId
              ? orderHeader?.saleChanelId
              : 67,
          saleId: employeeSalesId,
          deptId: departmentId,
          printInvoiceCheck: orderHeader?.printInvoiceCheck,
          attribute2: accountantId, //Nguyễn Trang Quyên-0009
          attribute18: employeeSalesRevenueId,
          contractcode: contractcode,
          orderTypeId: 1,
          branchId: branchId ? branchId : 488,
          amountTotal: payableAmount,
          amountDiscount: totalKMLine,
          amountVat: 0,
          attribute1: JSON.stringify({
            ...dataDeliveryInformation,
            branchId: branchId,
          }),
          createDate: orderHeader?.orderDate,
          orderNumberLink: location?.state?.orderNumberOld,
          attribute8:
            customerCheck?.name && customerCheck?.code
              ? `${customerCheck.name}||${customerCheck.code}`
              : "",
          attribute16: customerCheck?.attribute1,
          attribute31: customerCheck?.attribute4,
          attribute70: currentDiscountSuggestionData?.customerGroup ?? null,
        },
        isLock: isLock,
      });
      console.log("customerCheck", customerCheck);

      if (response && response.success) {
        // Kiểm tra isLimit để xác định trạng thái và thông báo
        if (isLock && isLimit) {
          setOrderStatus("DON_HANG_CHO_DUYET_GIAM");
          NotificationExtension.Success("Gửi duyệt thành công !");
        } else {
          setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");
          NotificationExtension.Success(
            isLock ? "Chốt đơn hàng thành công !" : "Lưu đơn hàng thành công !",
          );
        }

        SocketExtension.SendMessageToTopic<any>({
          topic: CREATEORDERSUCCESS,
          data: "",
        });
        return true;
      } else {
        NotificationExtension.Fails(
          response?.message ||
            (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !"),
        );
        return false;
      }
    } catch (error) {
      console.error("Error editing sales order:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi cập nhật đơn hàng!");
      return false;
    } finally {
      closeLoading();
    }
  }, 1000);

  //#region render ui
  const TableSelect: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10,
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th style={{ width: "70px" }}>Mã sản phẩm</Table.Th>
                <Table.Th style={{ width: "200px" }}>
                  Tên sản phẩm
                </Table.Th>{" "}
                {/* Đặt độ rộng cho cột "Tên sản phẩm" */}
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
                <Table.Th>Tồn kho</Table.Th>
                <Table.Th>SL chờ xuất</Table.Th>
                <Table.Th>SL khả dụng</Table.Th>
                <Table.Th>Bảo hành</Table.Th>
                <Table.Th>Mã kho</Table.Th>
                <Table.Th>Kho</Table.Th>
              </Table.Tr>
            </Table.Thead>

            {dataProducts?.length > 0 ? (
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="compact-sm"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={
                          handleCheckChooseProductBuon(product, listAdd) ||
                          product.tons - product.tonao <= 0
                        }
                      >
                        {handleCheckChooseProductBuon(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td style={{ width: "200px" }}>
                      {product.productName}
                    </Table.Td>{" "}
                    {/* Đặt độ rộng cho ô "Tên sản phẩm" */}
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                    <Table.Td>{product.tons}</Table.Td>
                    <Table.Td>{product.tonao}</Table.Td>
                    <Table.Td>{product.tons - product.tonao}</Table.Td>
                    <Table.Td>{`${product.warranty}`}</Table.Td>
                    <Table.Td>{product.wareHouseCode}</Table.Td>
                    <Table.Td>{product.warehouse}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            ) : (
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
              </Box>
            )}
          </Table>
        </div>
      </Table.ScrollContainer>
    );
  };

  const TableSelectDV: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          {/* Table Header (Fixed) */}
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10, // Đảm bảo tiêu đề luôn nằm trên cùng
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th>Mã sản phẩm</Table.Th>
                <Table.Th>Tên sản phẩm</Table.Th>
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
              </Table.Tr>
            </Table.Thead>
          </Table>

          {/* Table Body */}
          {dataProducts?.length > 0 ? (
            <Table striped withTableBorder>
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="xs"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={handleCheckChooseProductBuon(
                          product,
                          listAdd,
                        )}
                      >
                        {handleCheckChooseProductBuon(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td>{product.productName}</Table.Td>
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          ) : (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
            </Box>
          )}
        </div>
      </Table.ScrollContainer>
    );
  };

  const handleOnClickPrint = (id: any) => {
    setIsPrinting(true);
    setIdPrint(id);
  };

  const titleSell = () => {
    return (
      <>
        <_breadcrumb></_breadcrumb>
        <Group align="center" p={"0 10 10 10"} justify="space-between">
          <Flex gap={"xs"}>
            <Button
              disabled={orderStatus === "noCreate"}
              color={"blue"}
              size="xs"
              style={{
                pointerEvents: "auto",
              }}
              onClick={() => {
                window.location.reload();
              }}
            >
              Tạo mới
            </Button>
            <Tooltip
              label={isCollapse ? "Mở rộng" : "Thu gọn"}
              position="bottom"
            >
              <Group align="center">
                <Switch
                  size="sm"
                  color={isCollapse ? "red" : "green"}
                  checked={!isCollapse}
                  onChange={toggleCollapse}
                  label={isCollapse ? "Thu gọn (Ctrl+M)" : "Mở rộng (Ctrl+M)"}
                  thumbIcon={
                    !isCollapse ? (
                      <IconMaximize
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    ) : (
                      <IconMaximizeOff
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    )
                  }
                />
              </Group>
            </Tooltip>
          </Flex>
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <OrderStatus status={orderStatus || "noCreate"}></OrderStatus>
          </Flex>

          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            wrap="wrap"
            align="center"
            direction="row"
          >
            {orderStatus === "DON_HANG_HOAN_THANH" &&
            // !location?.state?.isReadOnly ? (
            true ? (
              <>
                <Button
                  leftSection={<IconPrinter size={20} />}
                  variant="outline"
                  color="indigo"
                  style={{
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  size="xs"
                  onClick={() => handleOnClickPrint(location?.state?.id)}
                >
                  In hóa đơn
                </Button>
              </>
            ) : (
              <></>
            )}
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT" ||
                !customerCheck?.name
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setModeSearch("SP");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm sản phẩm
            </Button>
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT" ||
                !customerCheck?.name
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setModeSearch("DV");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm dịch vụ
            </Button>
            <Button
              disabled={!customerCheck?.name}
              leftSection={<IconDiscount size={14} />}
              variant="outline"
              color="orange"
              size="xs"
              onClick={handleOpenDiscountSuggestion}
              loading={discountLoading}
              style={{ pointerEvents: "auto" }}
            >
              Xem gợi ý chiết khấu
            </Button>
            <Box
              style={{
                ...getStyle(),
              }}
            >
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon
                    style={{
                      pointerEvents:
                        orderStatus === "DON_HANG_HOAN_THANH" ? "none" : "auto",
                    }}
                    disabled={
                      location?.state?.actionType === "view" ||
                      location?.state?.actionType === "approved" ||
                      location?.state?.actionType === "payment"
                    }
                    size="md"
                    variant="outline"
                    color="blue"
                  >
                    <IconMenu2 style={{ width: rem(18), height: rem(18) }} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Label>Chức năng</Menu.Label>

                  <Menu.Item>
                    <Button
                      disabled={
                        orderStatus !== "DON_HANG_TAM" &&
                        orderStatus !== "DON_HANG_CHOT"
                      }
                      color={"red"}
                      size="xs"
                      onClick={() => handleClickCancelSalesOrder()}
                    >
                      Hủy đơn
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"blue"}
                      size="xs"
                      onClick={() => handleCopyItemCodes()}
                    >
                      copy mã hàng
                    </Button>
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Flex>
        </Group>
      </>
    );
  };

  function getStyle(includePayment = false): CSSProperties {
    const isDisabled =
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "approved" ||
      orderStatus === "DON_HANG_HOAN_THANH" ||
      orderStatus === "DON_HANG_CHO_DUYET_GIAM" ||
      (includePayment && location?.state?.actionType === "payment") ||
      (orderStatus === "DON_HANG_CHOT" &&
        location?.state?.actionType !== "payment") ||
      isHaveShipping;

    return {
      opacity: isDisabled ? 0.9 : 1,
      pointerEvents: isDisabled ? "none" : "auto",
    };
  }

  const formOrderHeader = () => {
    return (
      <Box
        style={{
          padding: 5,
          height: "100%",
          position: "relative",
          ...getStyle(),
        }}
      >
        <Box
          style={{
            ...getStyle(true),
          }}
        >
          <Grid>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Mã đơn hàng:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>{orderHeader?.orderNumber}</Text>
              </Flex>
              {(location?.state?.orderNumberOld ||
                orderHeader?.orderNumberLink) && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Mã ĐH cũ:<span style={{ color: "red" }}>*</span>
                  </Text>
                  <Text fw={500}>
                    {orderHeader?.orderNumberLink
                      ? orderHeader?.orderNumberLink
                      : location?.state?.orderNumberOld}
                  </Text>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Chi nhánh:"
                  value={branchName}
                  options={handleGetNameBranch(listBranch) || []}
                  onChange={(value: any) => {
                    setBranchName(value);
                    const BranchId = listBranch.find((item) => {
                      return item.text == value;
                    });
                    setBranchId(Number(BranchId?.value));
                    setListAdd([]);
                    setDataProducts([]);
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="Bộ phận:"
                  value={department}
                  options={handleGetNameDepartment(listDepartment)}
                  onChange={(value) => {
                    setDepartment(value);
                    const departmentId = listDepartment?.find((item) => {
                      return item?.name === value;
                    });
                    setDepartmentId(departmentId?.departmentId);
                  }}
                  width="280px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="NV tạo đơn:"
                  value={employeeSalesName}
                  options={[]}
                  onChange={(value: any) => {
                    alert("");
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="NV hưởng số:"
                  value={employeeSalesRevenueName}
                  options={handleGetNameEmployeeAll(listEmployeeSales) || []}
                  onChange={(value: any) => {
                    setEmployeeSalesRevenueName(value);
                    const saleRevenueId = listEmployeeSales.find((item) => {
                      return `${item?.fullname} - ${item?.code}` === value;
                    });
                    setEmployeeSalesRevenueId(saleRevenueId?.id);
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Mã ĐTCN:</Text>
                <Box style={{ position: "relative", maxWidth: "200px" }}>
                  <Tooltip
                    label={
                      orderHeader?.attribute16 || customerCheck?.attribute1
                    }
                    disabled={
                      !orderHeader?.attribute16 && !customerCheck?.attribute1
                    }
                  >
                    <Text fw={500} truncate>
                      {orderHeader?.attribute16 ||
                        customerCheck?.attribute1 ||
                        "Tìm mã ĐTCN"}
                    </Text>
                  </Tooltip>
                  <IconSearch
                    size={20}
                    style={{
                      position: "absolute",
                      right: -30,
                      top: 0,
                      cursor: "pointer",
                      color: cobalt_blue.base,
                    }}
                    onClick={() => openFormCustomer(true)}
                  />
                </Box>
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Khách hàng:<span style={{ color: "red" }}>*</span>
                </Text>
                <Box style={{ position: "relative", maxWidth: "200px" }}>
                  <Tooltip
                    label={customerCheck?.name}
                    disabled={!customerCheck?.name}
                  >
                    <Text fw={500} truncate>
                      {customerCheck?.type === 1
                        ? customerCheck?.name || "Tìm khách hàng"
                        : customerCheck?.companyName || "Tìm khách hàng"}
                    </Text>
                  </Tooltip>
                  <IconSearch
                    size={20}
                    style={{
                      position: "absolute",
                      right: -30,
                      top: 0,
                      cursor: "pointer",
                      color: cobalt_blue.base,
                    }}
                    onClick={() => openFormCustomer(false)}
                  />
                </Box>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Người MH:"
                  value={orderHeader?.attribute36 || ""}
                  options={listBuyerName}
                  onChange={(value: any) => {
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute36: value,
                    }));
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                {!orderHeader?.attribute36 && (
                  <>
                    <Text style={{ flex: "0 0 100px" }}>
                      Số điện thoại:<span style={{ color: "red" }}>*</span>
                    </Text>
                    <Text style={{ flex: "0 0 100px", fontWeight: "500" }}>
                      {customerCheck?.telephoneNumber}
                    </Text>
                  </>
                )}
                <CustomerDetail
                  customerCheck={customerCheck}
                  attribute36={orderHeader?.attribute36}
                  orderType={1}
                ></CustomerDetail>
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian tạo:</Text>
                <Text fw={500}>
                  {formatDateString(orderHeader?.createDate)}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian HT:</Text>
                <Text fw={500}>
                  {formatDateString(formatOrderDate(orderHeader?.orderDate))}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Kênh bán:"
                  value={saleChanel}
                  options={handlerRenderOptionSelect(saleChanelList)}
                  onChange={(value) => {
                    setSaleChanel(value);
                    const id = saleChanelList?.find((item) => {
                      return item.name === value;
                    });
                    setSaleChanelId(id.id);
                  }}
                  width="280px"
                />
              </Flex>
              {location?.state?.actionType === "payment" && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                  <Text fw={500}>{userLogin?.fullname}</Text>
                </Flex>
              )}
              {location?.state?.actionType === "view" &&
                orderHeader?.orderStatus === "DON_HANG_HOAN_THANH" && (
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                    <Text fw={500}>{accountantName}</Text>
                  </Flex>
                )}
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Loại KH:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>
                  {customerCheck?.type
                    ? customerCheck?.type === 1
                      ? "Khách lẻ"
                      : "Khách doanh nghiệp"
                    : ""}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Thông tin HĐ:"
                  popoverLabel="Chọn thông tin HĐ:"
                  value={
                    (orderHeader?.printInvoiceCheck ?? 0) === 0
                      ? "Không"
                      : orderHeader?.printInvoiceCheck === 1
                        ? "Có"
                        : "Nợ"
                  }
                  options={["Không", "Có", "Nợ"]}
                  optionLabels={{
                    "Không": "KH tiêu dùng – HĐ khách lẻ",
                    "Có": "Có lấy hóa đơn",
                    "Nợ": "Nợ hóa đơn",
                  }}
                  onChange={(e) => {
                    setOrderHeader((prev) => ({
                      ...prev,
                      printInvoiceCheck:
                        e === "Không"
                          ? 0
                          : e === "Có"
                            ? 1
                            : e === "Nợ"
                              ? 2
                              : prev.printInvoiceCheck,
                    }));
                  }}
                />
              </Flex>
              {/* Icon để mở modal thông tin VAT - style giống các trường khác */}
              {(orderHeader?.printInvoiceCheck === 1 ||
                orderHeader?.printInvoiceCheck === 2) && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Thông tin xuất hóa đơn VAT:
                  </Text>
                  <ActionIcon
                    color="blue"
                    variant="light"
                    onClick={() => setTaxInfoModalOpened(true)}
                    title={
                      location?.state?.actionType === "view"
                        ? "Xem thông tin xuất hóa đơn VAT"
                        : "Chỉnh sửa thông tin xuất hóa đơn VAT"
                    }
                    style={{ pointerEvents: "auto" }}
                  >
                    <IconEdit size={18} />
                  </ActionIcon>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Yêu cầu DV:"
                  value={handleGetTechnicialRequireName(
                    orderHeader?.technicalRequired ?? 0,
                  )}
                  options={[
                    "Không",
                    "Lắp ráp(mới)",
                    "Kiểm tra(mới)",
                    "Lắp ráp(mới) + Kiểm tra(mới)",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      technicalRequired: handleGetTechnicialRequireId(e) ?? 0,
                    }))
                  }
                />
              </Flex>
              <Flex>
                <SelectBuildPc
                  value={parseAttribute19(orderHeader?.attribute19)}
                  onChange={(data) => {
                    const updatedAttribute19 = JSON.stringify({
                      machineCode: data.machineCode,
                      quantity: data.quantity,
                    });
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute19: updatedAttribute19,
                    }));
                  }}
                  required
                  label="Build Pc"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <SelectPaymentMethod
                  customerCheck={customerCheck}
                  required
                  width="230px"
                  label="PT thanh toán:"
                  value={orderHeader?.attribute24 || "Thu Tiền Ngay"}
                  shipping={shipping}
                  options={[
                    "Thu Tiền Ngay",
                    "Thu tiền sau lắp đặt",
                    "Giao Hàng Thu Tiền(COD)",
                    "Đã chuyển khoản",
                    "Trả góp",
                    "Đối Trừ Công Nợ",
                    "Công nợ nội bộ",
                    "Công Nợ 3 Ngày",
                    "Công Nợ 4 Ngày",
                    "Công Nợ 5 Ngày",
                    "Công Nợ 7 Ngày",
                    "Công Nợ 10 Ngày",
                    "Công Nợ 15 Ngày",
                    "Công Nợ 20 Ngày",
                    "Công Nợ 21 Ngày",
                    "Công Nợ 30 Ngày",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute24: e ?? "",
                    }))
                  }
                />
              </Flex>
              <Flex align="center" gap="xs" mt={-4}>
                <Text style={{ flex: "0 0 100px" }}>Mã hợp đồng:</Text>
                <TextInput
                  value={contractcode}
                  onChange={(e) => setContractcode(e.target.value)}
                  variant="unstyled"
                  size="md"
                  fs={"14px"}
                  fw={"500"}
                  placeholder="Nhập mã đợp đồng"
                />
              </Flex>
            </Grid.Col>
          </Grid>
          <Divider my="sm" mt={0} />
          <Grid mt={10}>
            <Grid.Col span={6}>
              <Flex
                align="center"
                gap="xs"
                style={isHaveShipping ? { pointerEvents: "auto" } : undefined}
              >
                <EditableTextWithOptions
                  required
                  label="Giao hàng:"
                  value={shipping}
                  options={["Nhận tại cửa hàng", "Giao hàng"]}
                  onChange={(val) => {
                    setShipping(val);
                    if (
                      val === "Nhận tại cửa hàng" &&
                      (orderHeader?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
                        orderHeader?.attribute24?.toLowerCase()?.includes("giao hàng thu tiền"))
                    ) {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute24: "Thu Tiền Ngay",
                      }));
                      NotificationExtension.Warn(
                        "Đã tự động chuyển PT thanh toán về 'Thu Tiền Ngay' do nhận tại cửa hàng!",
                      );
                    }
                  }}
                />
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Grid>
                {(shipping === "Nội bộ" ||
                  shipping === "Đối tác vận chuyển" ||
                  shipping === "Giao hàng") && (
                  <Grid.Col span={6}>
                    <Flex>
                      <Text style={{ flex: "0 0 57px" }}>
                        Chi tiết: <span style={{ color: "red" }}>*</span>
                      </Text>
                      <Button
                        style={{
                          pointerEvents:
                            location?.state?.actionType === "payment" ||
                            location?.state?.actionType === "approved"
                              ? "none"
                              : "auto",
                        }}
                        ml={10}
                        size="xs"
                        onClick={() => {
                          if (listAdd.length > 0) {
                            if (shipingVendor || true) {
                              openModalDeliveryInformation();
                            } else {
                              NotificationExtension.Warn(
                                "Chưa chọn đơn vị tiếp nhận !",
                              );
                            }
                          } else {
                            NotificationExtension.Warn(
                              "Chưa có sản phẩm trong đơn !",
                            );
                          }
                        }}
                        variant="transparent"
                      >
                        <IconTruck size={22} /> {/* Biểu tượng xe tải */}
                      </Button>
                    </Flex>
                  </Grid.Col>
                )}
              </Grid>
            </Grid.Col>
          </Grid>
        </Box>
        <Divider my={"sm"} />
        <Grid>
          {/* <Grid.Col span={12} pt={0} pb={0} mt={-4}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Xin giảm trên tổng đơn:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <NumberInput
                disabled={
                  totalXGDetail > 0 ||
                  location?.state?.actionType === "payment" ||
                  location?.state?.actionType === "view" ||
                  location?.state?.actionType === "approved" ||
                  listAdd.length === 0
                    ? true
                    : false
                }
                variant="unstyled"
                autoFocus
                style={{ height: 38 }}
                size="md"
                fw={"500"}
                placeholder={"Nhập số tiền"}
                hideControls
                value={orderHeader?.discountAddedTotal || ""}
                thousandSeparator="."
                decimalSeparator=","
                onChange={(e) =>
                  setOrderHeader({
                    ...orderHeader,
                    discountAddedTotal: Number(e),
                  })
                }
                clampBehavior="strict"
                min={1}
                max={1000000000}
                allowDecimal={false}
                allowNegative={false}
              />
            </Flex>
          </Grid.Col> */}
          {/* Ô nhập mới: Khuyến mãi tổng đơn */}
          <Grid.Col span={12} pt={0} pb={0}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px", whiteSpace: "nowrap" }}>
                Khuyến mãi tổng đơn:
              </Text>
              <Flex
                align="center"
                gap={6}
                style={{ width: "25%", pointerEvents: "auto" }}
              >
                <PromotionDescriptionPopover
                  value={orderHeader?.attribute97 || ""}
                  onChange={(val) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute97: val,
                      amountDiscountTotal: !val.trim()
                        ? 0
                        : prev.amountDiscountTotal,
                    }))
                  }
                  amountDiscountTotal={orderHeader?.amountDiscountTotal || 0}
                  readOnly={
                    location?.pathname === "/sell/view-order" ||
                    location?.state?.actionType === "payment" ||
                    location?.state?.actionType === "view" ||
                    location?.state?.actionType === "approved"
                  }
                  disabled={
                    listAdd.length === 0 &&
                    location?.state?.actionType !== "view" &&
                    location?.state?.actionType !== "approved" &&
                    location?.state?.actionType !== "payment"
                  }
                  opened={promoDescOpened}
                  onOpenedChange={setPromoDescOpened}
                />
              </Flex>
              <NumberInput
                disabled={
                  location?.state?.actionType === "payment" ||
                  location?.state?.actionType === "view" ||
                  location?.state?.actionType === "approved" ||
                  listAdd.length === 0 ||
                  !orderHeader?.attribute97?.trim()
                }
                variant="unstyled"
                style={{ height: 38 }}
                size="md"
                fw={"500"}
                placeholder={
                  !orderHeader?.attribute97?.trim()
                    ? "Cần nhập diễn giải KM"
                    : "Nhập số tiền khuyến mãi"
                }
                hideControls
                value={orderHeader?.amountDiscountTotal || ""}
                thousandSeparator="."
                decimalSeparator=","
                onChange={(e) =>
                  setOrderHeader({
                    ...orderHeader,
                    amountDiscountTotal: Number(e),
                  })
                }
                clampBehavior="strict"
                min={1}
                max={1000000000}
                allowDecimal={false}
                allowNegative={false}
              />
            </Flex>
          </Grid.Col>

          {/* Nợ khuyến mãi - đặt gần với khuyến mãi tổng đơn */}
          <Grid.Col span={12} pt={2} pb={0}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Nợ khuyến mãi:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <Checkbox
                checked={orderHeader?.attribute80 === "1"}
                onChange={(event) => {
                  const isChecked = event.currentTarget.checked;
                  setOrderHeader({
                    ...orderHeader,
                    attribute80: isChecked ? "1" : "0",
                  });
                }}
                disabled={
                  location?.state?.actionType === "payment" ||
                  location?.state?.actionType === "view" ||
                  location?.state?.actionType === "approved" ||
                  listAdd.length === 0
                }
                styles={{
                  label: {
                    fontSize: "14px",
                    fontWeight: 500,
                  },
                }}
              />
            </Flex>
          </Grid.Col>
        </Grid>
        <Divider my="sm" />
        <Grid>
          <Grid.Col span={12} pt={0} pb={0}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Tổng tiền hàng:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <Text fw={"500"}>
                <NumberFormatter
                  value={
                    containsDT(orderHeader?.orderNumber) &&
                    location?.state?.actionType !== "doi"
                      ? orderHeader?.amountTotal
                      : totalAmount || 0
                  }
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </Text>
            </Flex>
          </Grid.Col>
          <Grid.Col span={12} pt={0} pb={0}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Tổng giảm trừ:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <Text fw={"500"}>
                <NumberFormatter
                  value={
                    (totalKM +
                      (totalXGDetail ?? 0) +
                      (orderHeader?.discountAddedTotal ?? 0) || 0) === 0
                      ? 0
                      : `-${
                          totalKM +
                            (totalXGDetail ?? 0) +
                            (orderHeader?.discountAddedTotal ?? 0) || 0
                        }`
                  }
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </Text>
            </Flex>
          </Grid.Col>
          <Grid.Col span={12} pt={0} pb={0}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Số tiền cần thanh toán:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <Text fw={"500"} style={{ color: "red" }}>
                <NumberFormatter
                  style={{ fontSize: "17px" }}
                  value={
                    location?.state?.actionType === "view"
                      ? orderHeader?.amountTotal
                      : payableAmount - orderHeader?.amountPaid
                  }
                  thousandSeparator="."
                  decimalSeparator=","
                />
                {` (Đã VAT) `}
              </Text>
            </Flex>
          </Grid.Col>
        </Grid>
        <Divider my={"sm"} />
        <Grid>
          <Grid.Col span={12} pt={0} pb={0} h={"fit-content"}>
            <Flex align="center" gap="xs" style={{ pointerEvents: "auto" }}>
              <Text fs={"16px"} fw={"500"} style={{ flex: "0 0 150px" }}>
                Thanh toán trước:
              </Text>
              {location?.state?.actionType === "view" &&
                orderHeader?.orderStatus === "DON_HANG_HOAN_THANH" && (
                  <>
                    <Text fw={500} style={{ width: "25%" }}></Text>
                    <PaymentDetails
                      orderNumber={orderHeader?.orderNumber}
                    ></PaymentDetails>
                  </>
                )}
            </Flex>
          </Grid.Col>
          <Grid.Col span={12} pb={0} mt={-12} h={"fit-content"}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Tiền mặt:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <NumberInput
                disabled={location?.state?.actionType !== "payment"}
                variant="unstyled"
                autoFocus
                style={{ height: 32 }}
                size="md"
                fw={"500"}
                placeholder={"Nhập số tiền"}
                hideControls
                value={
                  dataPayment ? getPayAmountByPayType("02") : cashPayment || ""
                }
                thousandSeparator="."
                decimalSeparator=","
                onChange={(e) => handleChangePrice(e, "cashPayment")}
                clampBehavior="strict"
                min={1}
                max={1000000000000}
                allowNegative={false}
                allowDecimal={false}
              />
            </Flex>
          </Grid.Col>
          <Grid.Col span={12} pb={0} h={"fit-content"}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Chuyển khoản:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <NumberInput
                disabled={location?.state?.actionType !== "payment"}
                variant="unstyled"
                autoFocus
                style={{ height: 32 }}
                size="md"
                fw={"500"}
                placeholder={"Nhập số tiền"}
                hideControls
                value={
                  dataPayment ? getPayAmountByPayType("01") : bankTransfer || ""
                }
                thousandSeparator="."
                decimalSeparator=","
                onChange={(e) => handleChangePrice(e, "bankTransfer")}
                min={1}
                max={10000000000}
                clampBehavior="strict"
                allowNegative={false}
                allowDecimal={false}
              />
              {!(
                location?.state?.actionType == "approved" ||
                location?.state?.actionType !== "payment"
              ) &&
                bankTransfer && (
                  <IconCreditCard
                    style={{
                      cursor: "pointer",
                      color: cobalt_blue.base, // Adjust color if needed
                    }}
                    onClick={() =>
                      openModalPaymentMb(bankTransfer, anotherPayment)
                    }
                  />
                )}
            </Flex>
          </Grid.Col>
          <Grid.Col span={12} pb={0} h={"fit-content"}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>CK khác:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <NumberInput
                disabled={location?.state?.actionType !== "payment"}
                variant="unstyled"
                autoFocus
                style={{ height: 32 }}
                size="md"
                fw={"500"}
                placeholder={"Nhập số tiền"}
                hideControls
                value={
                  dataPayment
                    ? getPayAmountByPayType("08")
                    : anotherPayment || ""
                }
                thousandSeparator="."
                decimalSeparator=","
                onChange={(e) => handleChangePrice(e, "anotherPayment")}
                min={1}
                max={10000000000}
                clampBehavior="strict"
                allowNegative={false}
                allowDecimal={false}
              />
            </Flex>
          </Grid.Col>
          <Grid.Col span={12} pb={0} h={"fit-content"}>
            <Flex align="center" gap="xs" direction="column">
              <Flex align="center" gap="xs" style={{ width: "100%" }}>
                <Text style={{ flex: "0 0 150px" }}>Thanh toán thẻ:</Text>
                <Text fw={500} style={{ width: "25%" }}></Text>
                <NumberInput
                  disabled={location?.state?.actionType !== "payment"}
                  variant="unstyled"
                  autoFocus
                  style={{ height: 32 }}
                  size="md"
                  fw={"500"}
                  placeholder={"Nhập số tiền"}
                  hideControls
                  value={
                    dataPayment
                      ? getPayAmountByPayType("03")
                      : cardPayment || ""
                  }
                  thousandSeparator="."
                  decimalSeparator=","
                  onChange={(value) => handleChangePrice(value, "cardPayment")}
                  min={1}
                  max={10000000000}
                  clampBehavior="strict"
                  allowNegative={false}
                  allowDecimal={false}
                />
                {(cardPayment != 0 || dataPayment
                  ? getPayAmountByPayType("03")
                  : false) && (
                  <Select
                    placeholder="Chọn ngân hàng"
                    data={bankOptions}
                    value={dataPayment ? getCardBank() : selectedBank || ""}
                    onChange={(e) => setSelectedBank(e || "")}
                    style={{ width: "25%" }}
                    disabled={location?.state?.actionType !== "payment"}
                  />
                )}
              </Flex>
            </Flex>
          </Grid.Col>
          <Grid.Col span={12} pb={0} h={"fit-content"}>
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px" }}>Tổng:</Text>
              <Text fw={500} style={{ width: "25%" }}></Text>
              <Text fw={"500"}>
                <NumberFormatter
                  value={totalPaid || 0}
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </Text>
            </Flex>
          </Grid.Col>
          <>
            <Grid.Col span={12} py={0} h={"fit-content"}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 150px", fontWeight: "500" }}>
                  Thanh toán sau:
                </Text>
                <Box
                  style={{
                    width: "25%",
                    pointerEvents:
                      location?.state?.actionType === "payment" &&
                      orderStatus !== "DON_HANG_HOAN_THANH"
                        ? "auto"
                        : "none",
                  }}
                >
                  {/* <EditableTextWithOptions
                    isCod
                    label=""
                    value={
                      dataPaymentLatter
                        ? dataPaymentLatter?.payLaterMethod
                        : payLaterMethod
                    }
                    options={["Không", "COD", "Công nợ", "Trả góp"]}
                    onChange={setPayLaterMethod}
                  /> */}
                </Box>
                <Text fw={"500"} style={{ color: "red" }}>
                  <NumberFormatter
                    style={{ fontSize: "17px" }}
                    value={
                      location?.state?.actionType === "view"
                        ? orderHeader?.amountRemaining
                        : deferredPayment - orderHeader?.amountPaid
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                  />
                </Text>
                {/* Nút bấm hiển thị modal nếu điều kiện phù hợp */}
                {/* {payLaterMethod === "Công nợ" && (
                  <Button
                    size="xs"
                    onClick={() => handleOpenModal("Công nợ")}
                    style={{
                      marginLeft: "10px",
                      pointerEvents:
                        location?.state?.actionType === "view" ||
                        location?.state?.actionType === "payment"
                          ? "auto"
                          : "none",
                    }}
                  >
                    Nhập công nợ
                  </Button>
                )} */}
                {payLaterMethod === "Trả góp" && (
                  <Button
                    size="xs"
                    onClick={() => handleOpenModal("Trả góp")}
                    style={{
                      marginLeft: "10px",
                      pointerEvents:
                        location?.state?.actionType === "view" ||
                        location?.state?.actionType === "payment"
                          ? "auto"
                          : "none",
                    }}
                  >
                    Nhập trả góp
                  </Button>
                )}
              </Flex>
            </Grid.Col>

            {/* Modal Công nợ */}
            <Modal
              style={{
                pointerEvents:
                  location?.state?.actionType === "payment" &&
                  orderStatus !== "DON_HANG_HOAN_THANH"
                    ? "auto"
                    : "none",
              }}
              opened={modalType === "Công nợ"}
              onClose={handleCloseModal}
              title="Nhập thông tin Công nợ"
              centered
            >
              {/* Hiển thị thông báo thời hạn công nợ mặc định */}
              <Text size="sm" color="dimmed" mb="sm" mt={10}>
                Thời hạn công nợ mặc định là{" "}
                <strong>{customerCheck?.debtTerm || 0}</strong> ngày. Tối đa có
                thể nhập là{" "}
                <strong>{(customerCheck?.debtTerm || 0) * 2}</strong> ngày.
              </Text>

              <TextInput
                label="Thời hạn công nợ"
                placeholder={`Nhập thời hạn (tối đa ${
                  (customerCheck?.debtTerm || 0) * 2
                } ngày)`}
                withAsterisk
                type="number"
                value={debtInfo.dueDate || ""}
                onChange={(e) => {
                  const newValue = e.target.value; // Lấy giá trị nhập vào
                  const numericValue = parseInt(newValue, 10);

                  // Cho phép giá trị rỗng hoặc số hợp lệ
                  if (
                    newValue === "" ||
                    (numericValue > 0 &&
                      numericValue <= (customerCheck?.debtTerm || 0) * 2)
                  ) {
                    setDebtInfo({ ...debtInfo, dueDate: newValue });
                  }
                }}
              />

              <Flex justify="end" mt="lg">
                <Button onClick={handleCloseModal} color="gray" mr="sm">
                  Hủy
                </Button>
                <Button
                  onClick={() => {
                    if (
                      debtInfo.dueDate === "" ||
                      parseInt(debtInfo.dueDate, 10) === 0
                    ) {
                      // Nếu giá trị nhập không hợp lệ (rỗng hoặc 0), có thể xử lý tại đây
                      console.log("Vui lòng nhập thời hạn công nợ hợp lệ");
                      return;
                    }
                    handleSaveDebt();
                  }}
                >
                  Lưu
                </Button>
              </Flex>
            </Modal>

            {/* Modal Trả góp */}
            <Modal
              opened={modalType === "Trả góp"}
              onClose={handleCloseModal}
              title="Nhập thông tin Trả góp"
              centered
            >
              <Tabs defaultValue="financialCompany">
                {/* Tab Công ty tài chính */}
                <Tabs.List>
                  <Tabs.Tab value="financialCompany">
                    Công ty tài chính
                  </Tabs.Tab>
                  <Tabs.Tab value="creditCard">Thẻ tín dụng</Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel
                  value="financialCompany"
                  pt="sm"
                  style={{
                    pointerEvents:
                      location?.state?.actionType === "payment" &&
                      orderStatus !== "DON_HANG_HOAN_THANH"
                        ? "auto"
                        : "none",
                  }}
                >
                  {/* <TextInput
                    label="Tên công ty"
                    placeholder="Nhập tên công ty"
                    withAsterisk
                    value={installmentInfo.companyName}
                    onChange={(e) =>
                      setInstallmentInfo({
                        ...installmentInfo,
                        companyName: e.target.value,
                      })
                    }
                  /> */}

                  <Select
                    label="Tên công ty"
                    placeholder="Chọn công ty"
                    data={[{ value: "hdsaigon", label: "HDSAISON" }]}
                    withAsterisk
                    value={
                      dataPaymentLatter?.installmentInfo?.companyName ||
                      installmentInfo.companyName
                    }
                    onChange={(value) =>
                      setInstallmentInfo({
                        ...installmentInfo,
                        companyName: value || "",
                      })
                    }
                  />
                  <TextInput
                    label="Mã hợp đồng"
                    placeholder="Nhập mã hợp đồng"
                    withAsterisk
                    value={
                      dataPaymentLatter?.installmentInfo?.contractCode ||
                      installmentInfo.contractCode
                    }
                    onChange={(e) =>
                      setInstallmentInfo({
                        ...installmentInfo,
                        contractCode: e.target.value,
                      })
                    }
                  />
                </Tabs.Panel>

                {/* Tab Thẻ tín dụng */}
                <Tabs.Panel
                  value="creditCard"
                  pt="sm"
                  style={{
                    pointerEvents:
                      location?.state?.actionType === "payment" &&
                      orderStatus !== "DON_HANG_HOAN_THANH"
                        ? "auto"
                        : "none",
                  }}
                >
                  <Select
                    label="Loại thẻ"
                    placeholder="Chọn loại thẻ"
                    data={[
                      { value: "payoo", label: "PAYOO" },
                      { value: "alepay", label: "ALEPAY" },
                    ]}
                    withAsterisk
                    value={
                      dataPaymentLatter?.installmentInfo?.cardType ||
                      installmentInfo.cardType
                    }
                    onChange={(value) =>
                      setInstallmentInfo({
                        ...installmentInfo,
                        cardType: value || "",
                      })
                    }
                  />
                </Tabs.Panel>
              </Tabs>

              <Flex
                justify="end"
                mt="lg"
                style={{
                  pointerEvents:
                    location?.state?.actionType === "payment" &&
                    orderStatus !== "DON_HANG_HOAN_THANH"
                      ? "auto"
                      : "none",
                }}
              >
                <Button onClick={handleCloseModal} color="gray" mr="sm">
                  Hủy
                </Button>
                <Button
                  onClick={() => {
                    handleSaveInstallment();
                  }}
                >
                  Lưu
                </Button>
              </Flex>
            </Modal>

            {/* Modal thông tin xuất hóa đơn VAT */}
            <Modal
              opened={taxInfoModalOpened}
              onClose={() => {
                // Kiểm tra nếu đang ở chế độ view thì cho phép đóng
                if (location?.state?.actionType === "view") {
                  setTaxInfoModalOpened(false);
                  return;
                }

                // Chỉ validate khi là "Có xuất VAT" (printInvoiceCheck === 1)
                // Không validate khi là "Không" hoặc "Nợ VAT"
                if (orderHeader?.printInvoiceCheck === 1) {
                  // Kiểm tra đủ 4 thông tin bắt buộc
                  // if (!taxInfo.TaxCode || !taxInfo.TaxCompany || !taxInfo.TaxEmail || !taxInfo.TaxAddress) {
                  //   NotificationExtension.Warn("Vui lòng nhập đầy đủ thông tin: Mã số thuế, Tên công ty, Email nhận hóa đơn và Địa chỉ công ty");
                  //   return;
                  // }

                  // Kiểm tra email hợp lệ
                  if (emailError) {
                    NotificationExtension.Warn(
                      "Email không đúng định dạng. Vui lòng kiểm tra lại!",
                    );
                    return;
                  }
                }

                setTaxInfoModalOpened(false);
              }}
              title="Thông tin xuất hóa đơn VAT"
              size="70vw"
              centered
              closeOnClickOutside={false}
              closeOnEscape={false}
            >
              <Grid>
                <Grid.Col span={6}>
                  <TextInput
                    label="Mã số thuế"
                    size="lg"
                    placeholder="Nhập mã số thuế"
                    value={taxInfo.TaxCode}
                    disabled={location?.state?.actionType === "view"}
                    withAsterisk
                    styles={{
                      input: {
                        fontSize: "16px",
                        color:
                          location?.state?.actionType === "view"
                            ? "#000 !important"
                            : undefined,
                        opacity:
                          location?.state?.actionType === "view"
                            ? 1
                            : undefined,
                      },
                      label: {
                        fontSize: "15px",
                        fontWeight: 500,
                      },
                    }}
                    onChange={(e) => {
                      const newTaxInfo = {
                        ...taxInfo,
                        TaxCode: e.target.value,
                      };
                      setTaxInfo(newTaxInfo);
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute57: JSON.stringify(newTaxInfo),
                      }));
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Tên công ty"
                    size="lg"
                    placeholder="Nhập tên công ty"
                    value={taxInfo.TaxCompany}
                    disabled={location?.state?.actionType === "view"}
                    withAsterisk
                    styles={{
                      input: {
                        fontSize: "16px",
                        color:
                          location?.state?.actionType === "view"
                            ? "#000 !important"
                            : undefined,
                        opacity:
                          location?.state?.actionType === "view"
                            ? 1
                            : undefined,
                      },
                      label: {
                        fontSize: "15px",
                        fontWeight: 500,
                      },
                    }}
                    onChange={(e) => {
                      const newTaxInfo = {
                        ...taxInfo,
                        TaxCompany: e.target.value,
                      };
                      setTaxInfo(newTaxInfo);
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute57: JSON.stringify(newTaxInfo),
                      }));
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Email nhận hóa đơn"
                    size="lg"
                    placeholder="Nhập email"
                    value={taxInfo.TaxEmail}
                    disabled={location?.state?.actionType === "view"}
                    withAsterisk
                    error={emailError}
                    styles={{
                      input: {
                        fontSize: "16px",
                        color:
                          location?.state?.actionType === "view"
                            ? "#000 !important"
                            : undefined,
                        opacity:
                          location?.state?.actionType === "view"
                            ? 1
                            : undefined,
                      },
                      label: {
                        fontSize: "15px",
                        fontWeight: 500,
                      },
                    }}
                    onChange={(e) => {
                      const emailValue = e.target.value;
                      const newTaxInfo = { ...taxInfo, TaxEmail: emailValue };

                      // Validate email format
                      const emailRegex =
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                      if (emailValue && !emailRegex.test(emailValue)) {
                        setEmailError("Email không đúng định dạng");
                      } else {
                        setEmailError("");
                      }

                      setTaxInfo(newTaxInfo);
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute57: JSON.stringify(newTaxInfo),
                        attribute53: emailValue,
                      }));
                      setVatEmailList(emailValue);
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Địa chỉ công ty"
                    size="lg"
                    placeholder="Nhập địa chỉ"
                    value={taxInfo.TaxAddress}
                    disabled={location?.state?.actionType === "view"}
                    withAsterisk
                    styles={{
                      input: {
                        fontSize: "16px",
                        color:
                          location?.state?.actionType === "view"
                            ? "#000 !important"
                            : undefined,
                        opacity:
                          location?.state?.actionType === "view"
                            ? 1
                            : undefined,
                      },
                      label: {
                        fontSize: "15px",
                        fontWeight: 500,
                      },
                    }}
                    onChange={(e) => {
                      const addressValue = e.target.value;

                      // Kiểm tra nếu có dấu '-'
                      if (addressValue.includes("-")) {
                        NotificationExtension.Warn(
                          "Địa chỉ không được chứa ký tự '-'",
                        );
                        return; // Không cập nhật giá trị
                      }

                      const newTaxInfo = {
                        ...taxInfo,
                        TaxAddress: addressValue,
                      };
                      setTaxInfo(newTaxInfo);
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute57: JSON.stringify(newTaxInfo),
                      }));
                    }}
                  />
                </Grid.Col>
              </Grid>
            </Modal>
          </>
        </Grid>
        <Box>
          <Grid mt={5}>
            <Grid.Col span={12}>
              <Flex
                gap="xs"
                direction={{ base: "column", sm: "row" }}
                align="center"
                style={{
                  pointerEvents: "auto",
                }}
              >
                {/* Ghi chú đơn hàng */}
                <Textarea
                  readOnly={location?.state?.actionType === "payment"}
                  placeholder="Ghi chú đơn hàng"
                  size="lg"
                  style={{ flex: 1, cursor: "pointer" }}
                  defaultValue={orderHeader?.note || ""}
                  onChange={(e) => debouncedNoteChange(e.target.value)}
                />
                {/* Ghi chú thu ngân */}
                <Textarea
                  readOnly={location?.state?.actionType !== "payment"}
                  placeholder="Ghi chú thu ngân"
                  size="lg"
                  style={{ flex: 1 }}
                  defaultValue={orderHeader?.attribute23 || ""}
                  onChange={(e) => debouncedCashierNoteChange(e.target.value)}
                />
              </Flex>
            </Grid.Col>
          </Grid>
        </Box>
        <Flex columnGap={5}>
          {orderStatus === "DON_HANG_TAM" ? (
            <Flex mt={10} gap={"xs"}>
              <>
                {location?.state?.actionType !== "doi" && !isHaveShipping && (
                  <Button
                    style={{ pointerEvents: "auto" }}
                    color="blue"
                    size="sm"
                    loading={loading}
                    disabled={
                      listAdd.length === 0 ||
                      location?.state?.actionType === "approved" ||
                      location?.state?.actionType === "view"
                    }
                    onClick={() => handleEditSalesOrder(false)}
                  >
                    Lưu
                  </Button>
                )}
                <Button
                  style={{ pointerEvents: "auto" }}
                  color="green"
                  size="sm"
                  loading={loading}
                  disabled={
                    listAdd.length === 0 ||
                    location?.state?.actionType === "approved" ||
                    location?.state?.actionType === "view"
                  }
                  onClick={() => handleEditSalesOrder(true)}
                >
                  Chốt đơn
                </Button>
              </>
            </Flex>
          ) : orderStatus === "DON_HANG_CHO_DUYET_GIAM" ? (
            <Flex mt={10} gap={"xs"}>
              <Text c="orange" fw={500} size="sm">
                🔒 Đơn hàng đang chờ duyệt giảm giá...
              </Text>
            </Flex>
          ) : (
            orderStatus !== "DON_HANG_HOAN_THANH" && (
              <>
                {location?.state?.actionType === "payment" ? (
                  <>
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        color="green"
                        size="sm"
                        disabled={deferredPayment < 0}
                        onClick={() => openModalPaymentBase()}
                        mt={10}
                      >
                        Hoàn thành
                      </Button>
                    </Flex>
                    {(orderHeader?.amountDiscountTotal ||
                      orderHeader?.discountAddedTotal) && (
                      <Flex mt={10} gap={"xs"}>
                        <Button
                          color="blue"
                          size="sm"
                          disabled={isDisablePhanBo}
                          onClick={() => handleAllocateItems()}
                          mt={10}
                        >
                          Phân bổ
                        </Button>
                      </Flex>
                    )}
                  </>
                ) : (
                  <>
                    <Flex mt={10} gap={"xs"}>
                      {location?.state?.actionType !== "doi" &&
                        !isHaveShipping && (
                          <Button
                            style={{ pointerEvents: "auto" }}
                            color="cyan"
                            size="sm"
                            loading={loading}
                            disabled={
                              orderStatus === "DON_HANG_CHOT" ||
                              orderStatus === "DON_HANG_HUY" ||
                              orderStatus === "DON_HANG_CHO_DUYET_GIAM" ||
                              location?.state?.actionType === "approved" ||
                              location?.state?.actionType === "view"
                            }
                            onClick={() => handleCreateSalesOrder(false)}
                          >
                            Lưu
                          </Button>
                        )}
                    </Flex>
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        style={{ pointerEvents: "auto" }}
                        color="green"
                        size="sm"
                        loading={loading}
                        disabled={
                          orderStatus === "DON_HANG_CHOT" ||
                          orderStatus === "DON_HANG_HUY" ||
                          orderStatus === "DON_HANG_CHO_DUYET_GIAM" ||
                          location?.state?.actionType === "approved" ||
                          location?.state?.actionType === "view"
                        }
                        onClick={() => handleCreateSalesOrder(true)}
                      >
                        Chốt đơn
                      </Button>
                    </Flex>
                    {/* Nút Gửi duyệt khi có discount được chọn */}
                    {listAdd.some((item) => item.discountAdded > 0) && (
                      <Flex mt={10} gap={"xs"}>
                        <Button
                          style={{ pointerEvents: "auto" }}
                          color="orange"
                          size="sm"
                          disabled={
                            orderStatus === "DON_HANG_CHOT" ||
                            orderStatus === "DON_HANG_HUY" ||
                            location?.state?.actionType === "approved" ||
                            location?.state?.actionType === "view" ||
                            !customerCheck?.code
                          }
                          onClick={async () => {
                            // Logic gửi duyệt với isLimit
                            const hasHighDiscount = listAdd.some((item) => {
                              const discountData =
                                discountSuggestionData?.itemPrices?.find(
                                  (price: any) =>
                                    price.itemCode === item.itemCode,
                                );
                              return (
                                item.discountAdded >
                                (discountData?.discountPrice3 || 0)
                              );
                            });

                            const isLimit = hasHighDiscount;

                            try {
                              const response = await repositoryPos.post<
                                MessageResponse<any>
                              >("/api/v1/CreateSellItem/approve-order-v2", {
                                orderHeader: {
                                  ...orderHeader,
                                  orderNumber: orderHeader?.orderNumber,
                                },
                                orderDetail: listAdd,
                                isLimit: isLimit,
                              });

                              if (response?.success) {
                                const message = isLimit
                                  ? "Gửi duyệt thành công! Đơn hàng cần duyệt cấp cao do vượt hạn mức."
                                  : "Gửi duyệt thành công!";
                                NotificationExtension.Success(message);
                                setOrderStatus("DON_HANG_CHO_DUYET_GIAM");
                              } else {
                                NotificationExtension.Fails(
                                  response?.message || "Gửi duyệt thất bại!",
                                );
                              }
                            } catch (error) {
                              console.error("Error approving order:", error);
                              NotificationExtension.Fails(
                                "Có lỗi xảy ra khi gửi duyệt!",
                              );
                            }
                          }}
                        >
                          Gửi duyệt
                        </Button>
                      </Flex>
                    )}
                  </>
                )}
              </>
            )
          )}
          {location?.state?.actionType === "approved" &&
            orderStatus === "DON_HANG_CHO_DUYET_GIAM" && (
              <>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="cyan"
                    size="sm"
                    onClick={() => handleOpenApprovalWithNote()}
                    style={{ pointerEvents: "auto" }}
                  >
                    Duyệt giảm
                  </Button>
                </Flex>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="red"
                    size="sm"
                    onClick={() =>
                      handleDeleteOrder(orderHeader?.orderNumber, "approved")
                    }
                    style={{ pointerEvents: "auto" }}
                  >
                    Không duyệt
                  </Button>
                </Flex>
              </>
            )}
        </Flex>
      </Box>
    );
  };

  //#region openConfirmModal
  function openFormCustomer(isChooseCongNo: boolean) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin danh sách khách hàng</Title>
        </>
      ),
      size: "90vw",
      children: (
        <CustomerInformation
          isChooseCongNo={isChooseCongNo}
          handleChooseCustomer={handleChooseCustomer}
          navigate={navigate}
          // isDisablePersonalCustomer={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormVoucher(row: MRT_Row<dataOrderDetailTable>) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Màn hình chọn chính sách khuyến mãi</Title>
        </>
      ),
      size: "70vw",
      children: (
        <VoucherRefactor
          branchId={branchId || 0}
          idItem={row?.original?.itemId?.toString() || row?.id}
          price={row.original.priceOnPriceList}
          handleSelectProductAddOn={handleSelectProductAddOn}
          handleSelectProductGift={handleSelectProductGift}
          handleSelectPromotionMain={handleSelectPromotionMain}
          handleRemovePromotion={handleRemovePromotion}
          isWholesale={true}
          currentIdPromote={row.original.idPromote}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const openModalPayment = (priceVnPay: number) =>
    modals.openConfirmModal({
      title: <Title order={5}>Thanh toán VN PAY</Title>,
      children: (
        <PaymentMethod
          price={priceVnPay}
          productCode={orderHeader?.orderNumber}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "550px",
    });

  const openModalPaymentMb = (price: number, anotherPayment: number) =>
    modals.openConfirmModal({
      title: <Title order={5}>Thanh toán chuyển khoản</Title>,
      children: (
        <PaymentMethodMb
          isDVT={listBranch?.find((item: any) => Number(item.value) === Number(branchId))?.attr6 === "DVT"}
          isPaymentMbSuccess={isPaymentMbSuccess}
          setIsPaymentMbSuccess={setIsPaymentMbSuccess}
          setTransactionCodeMb={setTransactionCodeMb}
          selectedBankReserve={selectedBankReserve}
          transactionCodeReserve={transactionCodeReserve}
          setSelectedBankReserve={setSelectedBankReserve}
          setTransactionCodeReserve={setTransactionCodeReserve}
          customerCheck={customerCheck}
          orderNumber={orderHeader.orderNumber}
          setPaymentDone={setPaymentDone}
          paymentDone={paymentDone}
          price={price + anotherPayment}
          productCode={orderHeader?.orderNumber}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "550px",
    });

  const openDeleteConfirmModal = (row: MRT_Row<dataOrderDetailTable>) => {
    return modals.openConfirmModal({
      title: "Bạn có chắc chắn xóa sản phẩm này?",
      children: (
        <Text size="lg" mt={15}>
          Bạn có chắc chắn muốn xóa ?
        </Text>
      ),
      labels: { confirm: "Xóa", cancel: "Thoát" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        const data = listAdd.filter((value) => value.id !== row.original.id);
        setListAdd(data);

        setListAdd((prevData) => {
          // xoá sp
          const data = prevData.filter(
            (item) =>
              item.id !== row.original?.id &&
              //xoá cả quà tặng kèm theo
              !row.original?.listIdGift?.includes(item?.id),
          );

          return data;
        });
      },
    });
  };

  const openModalDeliveryInformation = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Thông tin giao hàng</Title>,
      size: "70%",
      children: (
        <ModalDeliveryInformation
          attribute36={orderHeader?.attribute36}
          listAddress={listAddress}
          cod={
            containsDT(orderHeader?.orderNumber) &&
            location?.state?.actionType !== "doi"
              ? orderHeader?.amountTotal
              : deferredPayment - orderHeader?.amountPaid
          }
          readOnly={location?.state?.actionType === "view"}
          shipping={shipping}
          shipingVendor={shipingVendor}
          setShippingVendor={setShipingVendor}
          customerCheck={customerCheck}
          dataDeliveryInformation={dataDeliveryInformation}
          setDataDeliveryInformation={setDataDeliveryInformation}
          branchId={orderHeader?.orgId}
          listAdd={listAdd}
          payType={orderHeader?.attribute24}
          setIsHaveShipping={setIsHaveShipping}
          isHaveVat={
            orderHeader?.printInvoiceCheck === 1 ||
            orderHeader?.printInvoiceCheck === 2
          }
          orderHeader={orderHeader}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalPaymentBase = async () => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận hoàn tất thanh toán</Title>,
      children: (
        <>
          <Flex justify={"end"} gap={20} mt={"sm"}>
            <Button
              color="gray"
              leftSection={<IconWindow size={18} />}
              onClick={() => {
                modals.closeAll();
              }}
            >
              Huỷ
            </Button>
            <Button
              leftSection={<IconCheck size={18} />}
              onClick={() => {
                handleCallApiPayment();
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "400px",
      classNames: {
        title: "custom-modal-title",
        body: "custom-modal-body",
      },
    });
  };

  //#region Table sản phẩm
  const handleChangeRequestReduction = async (
    value: number | string,
    id: number,
    price: number,
  ) => {
    if (branchId) {
      setListAdd((prevList) => {
        return prevList.map((item) => {
          if (item.id === id) {
            const newValue =
              typeof value === "number" ? value : parseFloat(value);
            const validNewValue = isNaN(newValue) ? 0 : newValue;
            const newPriceFinal =
              price - validNewValue - (item.discountAmount || 0); // Thêm discountAmount
            return {
              ...item,
              discountAdded: validNewValue,
              priceFinal: newPriceFinal,
            };
          }
          return item;
        });
      });
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<dataOrderDetailTable>[]>(() => {
    return [
      {
        header: "STT",
        enableEditing: false,
        size: 30,
        Cell: ({ renderedCellValue, row }) => (
          <Text>{row.index === -1 ? "" : row.index + 1}</Text>
        ),
      },
      {
        accessorKey: "lineTyle",
        header: "Loại",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Text>
            <LineType status={row?.original?.lineTyle} />
          </Text>
        ),
        size: 110,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box style={{ pointerEvents: "auto" }}>
            <Tooltip label={renderedCellValue}>
              <Text w={200} style={{ whiteSpace: "normal" }} lineClamp={2}>
                {renderedCellValue}
              </Text>
            </Tooltip>
            {row?.original?.coBanLe === "N" ? (
              <Text
                size="md"
                fw={600}
                style={{
                  color: "#c92a2a",
                  margin: 0,
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <IconAlertCircle size={16} style={{ color: "#c92a2a" }} />
                Kinh doanh lưu ý — hàng không bán lẻ
              </Text>
            ) : null}
          </Box>
        ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        enableEditing: isCreating,
        enableSorting: false,
        size: 120,
        Edit: ({ cell, row, table, column }) => {
          return (
            <>
              <Menu
                opened={!!valueDebounced && dataProducts?.length > 0}
                trapFocus={false}
                shadow="md"
                width={"800"}
                position="bottom-start"
              >
                <Menu.Target>
                  <TextInput
                    autoFocus
                    onChange={async (e) => {
                      const _key = e.target.value ?? "";
                      setValueDebounced(_key);
                      handleSearch();
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (
                        e.key === "Enter" &&
                        dataProducts?.length === 1 &&
                        !listAdd.some(
                          (item) => item.itemCode === e.currentTarget.value,
                        )
                      ) {
                        setValueDebounced("");
                        handleSelectProduct(dataProducts[0], row?.index);
                        table.setCreatingRow(null);
                        handleSearch();
                      }
                    }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  {/* Nút đóng góc trên */}
                  <ActionIcon
                    onClick={() => {
                      setValueDebounced(""); // Đóng menu khi nút đóng được bấm
                      handleSearch();
                    }}
                    style={{
                      position: "absolute",
                      top: 4, // Điều chỉnh khoảng cách từ trên xuống
                      right: 20, // Điều chỉnh khoảng cách từ phải sang
                      zIndex: 11,
                      backgroundColor: "#f5f5f5", // Màu nền nhạt
                      border: "1px solid #ccc", // Viền nhẹ
                      borderRadius: "4%", // Bo tròn hoàn toàn
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)", // Hiệu ứng bóng
                      color: "#000", // Màu biểu tượng
                      width: "22px", // Kích thước nút
                      height: "2px", // Kích thước nút
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease", // Hiệu ứng mượt mà
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e0e0e0"; // Màu nền khi hover
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Trả về màu nền ban đầu
                    }}
                    variant="transparent"
                  >
                    <IconX size={22} />
                  </ActionIcon>
                  {modeSearch === "SP" ? (
                    <TableSelect
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(product, row?.index);
                      }}
                      rowIndex={row.index}
                    />
                  ) : (
                    <TableSelectDV
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(product, row?.index, "DV");
                      }}
                      rowIndex={row.index}
                    />
                  )}
                </Menu.Dropdown>
              </Menu>
            </>
          );
        },
      },
      {
        accessorKey: "attribute23", // Khóa để truy cập dữ liệu
        header: "Mã kho", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return <Text>{row?.original?.attribute23}</Text>; // Hiển thị giá trị
        },
      },

      {
        accessorKey: "primaryUomCode",
        header: "ĐVT",
        enableEditing: false,
        enableSorting: false,
        size: 50,
      },

      {
        accessorKey: "quality",
        header: "Số lượng",
        enableEditing: false,
        enableSorting: false,
        size: 80,
        Cell: ({ renderedCellValue, row }) => (
          <NumberInput
            disabled={!row?.original?.itemCode}
            min={1}
            max={100000}
            hideControls
            clampBehavior="strict"
            value={row.original.quality}
            onChange={(e) => {
              handleChangeQuantity(e, row);
            }}
            onBlur={(e) => {
              table.setEditingCell(null);
            }}
            onKeyDown={handleKeyDown}
            defaultValue={1}
            allowDecimal={false}
            allowNegative={false}
          />
        ),
      },
      {
        accessorKey: "priceOnPriceList",
        header: "Giá bán buôn",
        enableEditing: false,
        enableSorting: false,
        size: 170,
        Cell: ({ row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }
          const priceOptions = row?.original?.attribute18
            ? JSON.parse(row.original.attribute18)
            : {};

          const priceData = [
            { label: "Giá bán lẻ", value: priceOptions.retailPrice || "" },
            {
              label: "Giá buôn 1",
              value: priceOptions.wholesalePrice1 || "",
            },
            {
              label: "Giá buôn 2",
              value: priceOptions.wholesalePrice2 || "",
            },
            {
              label: "Giá buôn 3",
              value: priceOptions.wholesalePrice3 || "",
            },
          ].filter((item) => item.value && item.value !== 0); // Lọc bỏ giá trị 0 và rỗng

          const uniquePriceData = Array.from(
            new Map(priceData.map((item) => [item.value, item])).values(),
          );

          // Kiểm tra xem có giá buôn nào không dựa trên dữ liệu đã được filter
          const hasWholesalePrice = priceData.some(
            (item) =>
              item.label.includes("Giá buôn") && item.value && item.value !== 0,
          );

          // Kiểm tra nếu sản phẩm không có giá nào hoặc tất cả giá đều bằng 0
          const hasAnyPrice = uniquePriceData.length > 0;

          return (
            <Flex direction="column" gap="sm" rowGap={1}>
              {hasAnyPrice && (
                <RadioGroup
                  value={String(row.original.priceOnPriceList)}
                  onChange={(value) => {
                    setListAdd((prevData) =>
                      prevData.map((item, i) =>
                        i === row.index
                          ? {
                              ...item,
                              priceFinal: Number(value),
                              priceOnPriceList: Number(value),
                            }
                          : item,
                      ),
                    );
                  }}
                >
                  {uniquePriceData.map((option, index) => {
                    const valueString = String(option?.value);
                    return valueString ? (
                      <Radio
                        key={index}
                        value={valueString}
                        label={`${
                          option.label
                        }: ${option?.value?.toLocaleString()}`}
                      />
                    ) : null;
                  })}
                </RadioGroup>
              )}
              <Flex align="center" ml={hasAnyPrice ? "32px" : "0px"}>
                <NumberInput
                  size="xs"
                  placeholder="Nhập giá khác"
                  value={row.original.priceOnPriceList}
                  onChange={(value) => {
                    if (value !== null) {
                      setListAdd((prevData) =>
                        prevData.map((item, i) =>
                          i === row.index
                            ? {
                                ...item,
                                priceFinal: Number(value),
                                priceOnPriceList: Number(value),
                              }
                            : item,
                        ),
                      );
                    }
                  }}
                  hideControls
                  thousandSeparator="."
                  decimalSeparator=","
                  styles={{
                    input: {
                      height: "30px",
                      fontSize: "14px",
                      padding: "4px",
                    },
                  }}
                />
              </Flex>
            </Flex>
          );
        },
      },
      {
        header: "KM",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => {
          const [customDiscount, setCustomDiscount] = React.useState<
            number | null
          >(row.original.discountAmount || null);
          const [warning, setWarning] = React.useState<string | null>(null);

          // Hàm cập nhật giá trị vào danh sách
          const handleDiscountChange = (value: number | null) => {
            if (value !== null && value > row.original.priceOnPriceList) {
              setWarning("KM không được lớn hơn giá sản phẩm");
              return;
            }
            setWarning(null);
            setCustomDiscount(value);

            setListAdd((prevData) =>
              prevData.map((item, i) => {
                if (i === row.index) {
                  const updatedDiscountAmount = value || 0;
                  const updatedPriceFinal =
                    row.original.priceOnPriceList -
                    updatedDiscountAmount -
                    (row.original.discountAdded || 0);

                  return {
                    ...item,
                    discountAmount: updatedDiscountAmount,
                    priceFinal: updatedPriceFinal > 0 ? updatedPriceFinal : 0, // Đảm bảo không âm
                  };
                }
                return item;
              }),
            );
          };

          const calculatedDiscount =
            customDiscount ??
            (row.original.discountRate
              ? -(
                  (row.original.discountRate * row.original.priceOnPriceList) /
                  100
                )
              : -(row.original.discountAmount || 0));

          return (
            <Flex
              direction="column"
              align="start"
              style={{
                padding: "5px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                backgroundColor: "#f9f9f9",
                gap: "5px",
              }}
            >
              {/* Giá trị giảm hiển thị */}
              <Flex
                align="center"
                justify="space-between"
                style={{ width: "100%" }}
              >
                <Box style={{ fontWeight: 600 }}>Giảm CTKM:</Box>
                <Box style={{ color: "red", fontWeight: 600, marginRight: 4 }}>
                  <NumberFormatter
                    value={calculatedDiscount}
                    thousandSeparator="."
                    decimalSeparator=","
                  />
                </Box>
              </Flex>

              {/* Ô nhập liệu riêng biệt */}
              <Flex
                align="center"
                justify="space-between"
                style={{ width: "100%" }}
              >
                <Box style={{ fontWeight: 600 }}>Giảm tự nhập:</Box>
                <NumberInput
                  size="xs"
                  hideControls
                  value={customDiscount ?? ""}
                  onChange={(e) => handleDiscountChange(Number(e) || null)}
                  thousandSeparator="."
                  decimalSeparator=","
                  style={{
                    width: "60px",
                    marginLeft: "4px",
                    borderRadius: "4px",
                  }}
                />
              </Flex>

              {/* Hiển thị cảnh báo nếu có */}
              {warning && (
                <Box
                  style={{
                    color: "orange",
                    fontSize: "12px",
                    marginTop: "5px",
                    textAlign: "center",
                  }}
                >
                  {warning}
                </Box>
              )}
            </Flex>
          );
        },
      },
      // {
      //   accessorKey: "discount",
      //   header: "Xin giảm",
      //   enableEditing: false,
      //   enableSorting: false,
      //   size: 130,
      //   Cell: ({ renderedCellValue, row }) => {
      //     // Tạo hàm debounce với Mantine
      //     const debouncedHandleChange = useDebouncedCallback(
      //       (value) => {
      //         handleChangeRequestReduction(
      //           value,
      //           row.original.id,
      //           row?.original?.priceOnPriceList
      //         );
      //       },
      //       500 // 300ms là thời gian debounce
      //     );

      //     return (
      //       <NumberInput
      //         disabled
      //         style={{ height: 35 }}
      //         size="sm"
      //         fw={"500"}
      //         hideControls
      //         thousandSeparator="."
      //         decimalSeparator=","
      //         value={row.original?.discountAdded}
      //         onChange={(e) => {
      //           debouncedHandleChange(e);
      //         }}
      //         min={1}
      //         max={1000000000}
      //         clampBehavior="strict"
      //         onKeyDown={handleKeyDown}
      //         allowDecimal={false}
      //         allowNegative={false}
      //       />
      //     );
      //   },
      // },
      {
        accessorKey: "priceFinal",
        header: "Thành tiền",
        size: 80,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }
          const { priceFinal, quality } = row.original;
          console.log("priceFinal", priceFinal);
          console.log("quality", quality);
          // Đảm bảo không có giá âm
          const displayedPrice = Math.max(priceFinal * quality, 0);

          return (
            <>
              <NumberFormatter
                value={displayedPrice}
                thousandSeparator="."
                decimalSeparator=","
              />
            </>
          );
        },
      },
      {
        accessorKey: "attribute20",
        header: "Bảo hành",
        size: 80,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          return <>{renderedCellValue ? `${renderedCellValue} tháng` : ""}</>;
        },
      },
      {
        accessorKey: "attribute28", // Khóa để truy cập dữ liệu
        header: "KM phân bổ", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={Math.round(Number(row?.original?.attribute28 || 0)) || ""}
              thousandSeparator="."
              decimalSeparator=","
            />
          ); // Hiển thị giá trị
        },
      },
      // {
      //   accessorKey: "attribute29", // Khóa để truy cập dữ liệu
      //   header: "Xin giảm phân bổ", // Tiêu đề của cột
      //   enableEditing: false, // Không cho phép chỉnh sửa
      //   enableSorting: false, // Tắt sắp xếp
      //   size: 80, // Độ rộng của cột
      //   Cell: ({ row }) => {
      //     return (
      //       <NumberFormatter
      //         value={Math.round(Number(row?.original?.attribute29 || 0)) || ""}
      //         thousandSeparator="."
      //         decimalSeparator=","
      //       />
      //     );
      //   },
      // },
      {
        accessorKey: "attribute35", // Thành tiền sau bổ
        header: "Thành tiền sau bổ", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={Math.round(Number(row?.original?.attribute35 || 0)) || ""}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        enableSorting: false,
        enableEditing: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            value={row.original.note || ""}
            onChange={(event) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, note: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },
      {
        accessorKey: "attribute16",
        header: "Chứng từ DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            value={row.original.attribute16 || ""}
            onChange={(event) => {
              console.log("event", event.target.value);
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute16: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },
      {
        accessorKey: "attribute17",
        header: "Giá DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <NumberInput
            value={row.original.attribute17 || 0} // Giá trị mặc định
            onChange={(value) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute17: Number(value) } // Đảm bảo giá trị là số
                    : item,
                ),
              );
            }}
            thousandSeparator="."
            decimalSeparator=","
            hideControls
            min={0}
            step={1000}
            placeholder="Nhập số tiền"
          />
        ),
      },
      {
        accessorKey: "attribute15",
        header: "LK giàn",
        enableSorting: false,
        enableEditing: false,
        size: 100,
        Cell: ({ row }) => (
          <Checkbox
            checked={row?.original?.attribute15 === "1"}
            onChange={(event) => {
              const isChecked = event.currentTarget.checked;
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute15: isChecked ? "1" : "0" }
                    : item,
                ),
              );
            }}
          />
        ),
      },
    ];
  }, [listAdd, dataProducts, isCreating, orderHeader?.discountAddedTotal, isHaveShipping]);

  const table = useMantineReactTable<dataOrderDetailTable>({
    columns,
    data: listAdd,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "Thao tác",
      },
    },
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row",
    editDisplayMode: "cell",
    enableEditing: !orderHeader?.attribute39 && !isHaveShipping,
    enableRowActions: true,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableTopToolbar: false,
    enableBatchRowSelection: true,
    positionActionsColumn: "last",
    enableExpandAll: false,

    renderRowActions: ({ row, table }) => (
      <Flex gap="4">
        {!row?.original?.attribute11 && !orderHeader?.attribute39 && !isHaveShipping && (
          <>
            <Tooltip label="Chọn chính sách khuyến mãi">
              <ActionIcon
                color={orange.base}
                variant="outline"
                disabled={
                  (!row.original?.listIdPromotion?.length &&
                    !row.original?.hasPromotion) ||
                  row?.original?.lineTyle === "DV" ||
                  row?.original?.lineTyle === "KM" ||
                  row?.original?.lineTyle === "HK"
                }
                onClick={async () => {
                  openFormVoucher(row);
                }}
              >
                <IconDiscount
                  style={{
                    color:
                      (!row.original?.listIdPromotion?.length &&
                        !row.original?.hasPromotion) ||
                      row?.original?.lineTyle === "DV" ||
                      row?.original?.lineTyle === "KM" ||
                      row?.original?.lineTyle === "HK"
                        ? "gray"
                        : orange.base,
                  }}
                />
              </ActionIcon>
            </Tooltip>
            {/* <Tooltip label="Chọn giá">
              <ActionIcon
                color="green"
                variant="outline"
                disabled={
                  !customerCheck?.code ||
                  row?.original?.lineTyle === "DV" ||
                  location?.state?.actionType === "view" ||
                  orderStatus === "DON_HANG_HOAN_THANH"
                }
                onClick={() => handleOpenDiscountSelection(row)}
              >
                <IconCurrencyDollar
                  style={{
                    color:
                      !customerCheck?.code ||
                      row?.original?.lineTyle === "DV" ||
                      location?.state?.actionType === "view" ||
                      orderStatus === "DON_HANG_HOAN_THANH"
                        ? "gray"
                        : "green",
                  }}
                />
              </ActionIcon>
            </Tooltip> */}
            <Tooltip label="Xoá sản phẩm">
              <ActionIcon variant="outline" color="red">
                <IconTrash onClick={() => openDeleteConfirmModal(row)} />
              </ActionIcon>
            </Tooltip>
          </>
        )}
        {/* Show disabled message when voucher is applied */}
        {orderHeader?.attribute39 && (
          <Tooltip label="Đã áp voucher - không thể chỉnh sửa" withArrow>
            <ActionIcon
              variant="subtle"
              color="red"
              style={{ cursor: "not-allowed" }}
            >
              <IconBan size={20} color="red" />
            </ActionIcon>
          </Tooltip>
        )}
        {/* Show disabled message when shipping info is saved */}
        {isHaveShipping && !orderHeader?.attribute39 && (
          <Tooltip label="Đã lưu thông tin giao hàng - không thể chỉnh sửa" withArrow>
            <ActionIcon
              variant="subtle"
              color="red"
              style={{ cursor: "not-allowed" }}
            >
              <IconBan size={20} color="red" />
            </ActionIcon>
          </Tooltip>
        )}
      </Flex>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
          mb={"xs"}
          style={{ opacity: 0 }}
        ></Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localizationSales,
    getRowId: (row) => row.id?.toString(),
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    initialState: {
      expanded: true,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-expand"],
        right: ["mrt-row-actions"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },

    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualSorting: false,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        ...styleCellTable(row),
        ...getStyle(true),
      },
    }),
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: handleCheckBackgroundColor(
          row?.original?.attribute11 || "",
        ),
      },
    }),
    enablePagination: false,
    enableBottomToolbar: false,
    state: {
      showAlertBanner: isError,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    enableColumnPinning: true,
    mantineTableProps: {},
  });

  //#region useEffect

  console.log("customerCheck", customerCheck);

  // Fetch user auth when component mounts
  useEffect(() => {
    const fetchUserAuth = async () => {
      try {
        const authData = await apiAuth.getUserAuth();
        setUserAuth(authData?.data);
        console.log("User Auth Data (WholeSale):", authData);
      } catch (error) {
        console.error("Error fetching user auth:", error);
        setUserAuth(null);
      }
    };

    fetchUserAuth();
  }, []);

  useEffect(() => {
    if (dataAllocate?.length > 0) {
      setListAdd((prevListAdd) => {
        return prevListAdd.map((item) => {
          const matchedAllocation: any = dataAllocate.find(
            (allocation: any) => allocation.itemId === item.itemId,
          );

          if (matchedAllocation) {
            const priceAfterAllocation =
              (item.priceFinal -
                matchedAllocation?.priceAllKM -
                matchedAllocation?.priceAll) *
              item.quality;

            return {
              ...item,
              attribute28: matchedAllocation?.priceAllKM,
              attribute29: matchedAllocation?.priceAll,
              attribute35: priceAfterAllocation.toString() || "", // Thành tiền sau khi phân bổ
            };
          }
          return item; // Trả về item gốc nếu không tìm thấy dữ liệu phù hợp trong dataAllocate
        });
      });
    }
  }, [dataAllocate]);

  useHotkeys([
    ["mod+J", () => console.log("Toggle color scheme")],
    [
      "ctrl+F5",
      () => {
        //  openNew();
      },
    ],
    [
      "F5",
      () => {
        //  openNew();
      },
    ],
    ["alt+mod+shift+X", () => console.log("Rick roll")],
    [
      "F11",
      () => {
        // openNew(true);
      },
    ],
    ["ctrl+M", () => toggleCollapse()],
  ]);

  // thêm logic bo phan sẽ ăn theo người hưởng số
  useEffect(() => {
    const foundEmployee = listEmployeeSales.find(
      (emp) => emp.id == employeeSalesRevenueId,
    );

    if (foundEmployee?.departmentId) {
      setDepartmentId(foundEmployee?.departmentId);
    }
  }, [employeeSalesRevenueId, listEmployeeSales]);

  useEffect(() => {
    const total = [cardPayment, cashPayment, vnpayPayment, bankTransfer]
      .filter((value) => value > 0) // Filter out values that are 0 or less
      .reduce((acc, curr) => acc + curr, 0); // Sum up the remaining values

    setTotalPaid(total);
  }, [cardPayment, cashPayment, vnpayPayment, bankTransfer]);

  useEffect(() => {
    setDeferredPayment(payableAmount - totalPaid);
  }, [payableAmount, totalPaid]);

  useEffect(() => {
    const fetchDataCreate = async () => {
      const url = `/api/v1/CreateSellItem/create?codePrefix=DH`;
      try {
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success && !orderHeader?.orderNumber) {
          setOrderHeader(response.data.orderHeader);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (orderHeader?.orderNumber || isFetchDataCalledRef.current) return;

    if (
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "edit" &&
      location?.state?.actionType !== "approved" &&
      location?.state?.actionType !== "doi"
    ) {
      fetchDataCreate();
      isFetchDataCalledRef.current = true; // Đặt flag để tránh gọi lại
    }
  }, [orderHeader, location?.state]);

  useEffect(() => {
    if (branchId && branchName) return;
    setBranchId(orderHeader?.orgId || 0);
    const name = listBranch?.find(
      (item: any) => item?.value == orderHeader?.orgId,
    );
    setBranchName(name?.text);
  }, [orderHeader, listBranch]);

  useEffect(() => {
    const handleCheckPayableAmount = (listAdd: any[]) => {
      let priceTotal = 0;

      if (location?.state?.actionType === "doi") {
        listAdd?.forEach((item) => {
          if (item?.attribute14 || item?.attribute2) {
            // Tính giá sản phẩm và cộng thêm attribute11 và attribute12
            const itemPrice =
              (item?.priceOnPriceList || 0) * (item?.quality || 0);
            const additionalAmount =
              (parseFloat(item?.attribute5) || 0) +
              (parseFloat(item?.attribute12) || 0);
            priceTotal += itemPrice + additionalAmount;
          }
        });
      } else {
        listAdd?.forEach((item) => {
          priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
        });
      }

      return priceTotal;
    };
    setListSerial(handleRenderOptionListAdd(listAdd));
    let priceTotal = handleCheckPayableAmount(listAdd);

    setTotalAmount(priceTotal);
    let totalXGDetail = listAdd.reduce((acc, item) => {
      const discountAdded = item.discountAdded || 0; // Lấy giá trị xin giảm, mặc định là 0 nếu không có
      return acc + discountAdded * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);
    const totalDiscount = listAdd.reduce((acc, item) => {
      const discountAmount = item.discountAmount || 0; // Lấy giá trị giảm giá, mặc định là 0 nếu không có
      return acc + discountAmount * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);

    const totalDiscountRate = listAdd.reduce((acc, item) => {
      const discountRate = item.discountRate || 0; // Giá trị phần trăm giảm giá
      const price = item.priceOnPriceList || 0; // Giá của sản phẩm
      const quality = item.quality || 1; // Số lượng sản phẩm
      const discountValue = (discountRate / 100) * price * quality; // Tính giá trị giảm giá
      return acc + discountValue; // Cộng dồn vào tổng
    }, 0);

    setTotalXGDetail(totalXGDetail); // Cập nhật tổng xin giảm
    setTotalKM(
      totalDiscount +
        totalDiscountRate +
        (orderHeader?.amountDiscountTotal || 0),
    );
    setTotalKMLine(totalDiscount + totalDiscountRate);
    setPayableAmount(
      (priceTotal ?? 0) -
        (totalDiscount ?? 0) -
        (totalDiscountRate ?? 0) -
        (orderHeader?.amountDiscountTotal ?? 0) -
        (totalXGDetail ?? 0) -
        (orderHeader?.discountAddedTotal ?? 0),
    );
  }, [listAdd, orderHeader, location?.state?.actionType]);

  // hàm lấy data ban đầu
  useEffect(() => {
    const userLogin = localStorage.getItem("userLogin");

    if (userLogin) {
      const userLoginObject = JSON.parse(userLogin);
      // gán người thanh toán chính là người bấm nút hoàn thành
      setUserLogin(userLoginObject);
    }

    const fetchDataBranch = async () => {
      const response = await repositoryPos.get<
        MessageResponse<TblDMPaymentMethod[]>
      >("/api/v1/TblDmInventory/get-select-branch?auth=false");

      if (response && response.success) {
        let result = response.data;
        setListBranch(result);
      }
    };

    const fetchDataSaleChanelId = async () => {
      const response = await repositoryMdm.get<MessageResponse<any[]>>(
        "/api/v1/TblDmSaleChanel/get-all",
      );

      if (response && response.success) {
        let result = response.data;
        setSaleChanelList(result);
      }
    };

    const fetchAllDepartment = async () => {
      const response = await repositoryPos.get<
        MessageResponse<DepartmentModel[]>
      >(`/api/v1/TblDepartment/get-all`);

      if (response && response.success) {
        let result = response.data;
        setListDepartment(result);
      } else {
      }
    };

    Promise.all([
      fetchDataSaleChanelId(),
      fetchAllDepartment(),
      fetchDataBranch(),
    ]);
  }, []);

  const [searchTrigger, setSearchTrigger] = useState(0);

  useEffect(() => {
    const fetchItemSell = async () => {
      const keySearch = valueDebounced.toLowerCase();
      const url =
        modeSearch === "SP"
          ? `/api/v1/TblItem/search-sell?inv=${branchId}&key=${keySearch}`
          : `/api/v1/TblItem/search-sell-service?inv=${branchId}&key=${keySearch}`;
      try {
        const searchResult =
          await repositoryPos.get<MessageResponse<ProductModel[]>>(url);
        if (searchResult?.data) {
          setDataProducts(searchResult.data);
        } else {
          setDataProducts([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setDataProducts([]);
      }
    };

    if (valueDebounced && valueDebounced.length > 2) {
      fetchItemSell();
    } else {
      setDataProducts([]);
    }
  }, [valueDebounced, branchId, modeSearch, searchTrigger]);

  const handleSearch = () => {
    setSearchTrigger((prev) => prev + 1); // Kích hoạt lại useEffect
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (270 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // Noti nếu thanh toán trước hơn thanh toán sau
  useEffect(() => {
    if (
      deferredPayment < 0 &&
      totalAmount !== 0 &&
      location?.state?.actionType !== "doi"
    ) {
      NotificationExtension.Warn(
        "Số tiền thanh toán lớn hơn tổng số tiền cần thanh toán của đơn!",
      );
    }
  }, [deferredPayment]);

  //region logic chọn chi nhánh
  useEffect(() => {
    const fetchDepartmentByBanchId = async () => {
      if (branchId) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDepartment/get-all?branchId=${branchId}`,
        );
        if (response && response.success) {
          let result = response.data;
          setListDepartment(result);
        }
      }
    };
    fetchDepartmentByBanchId();
  }, [branchId]);

  useEffect(() => {
    const fetchEmployeeByDepartmentId = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        let result = response.data;
        setListEmployeeSales(result);
      }
    };
    fetchEmployeeByDepartmentId();
  }, []);

  //region  logic sửa đơn hàng

  const fetchDetailSaleChanel = async (SaleChanelId: number) => {
    if (SaleChanelId) {
      const response = await repositoryMdm.get<MessageResponse<any>>(
        `/api/v1/TblDmSaleChanel/update?id=${SaleChanelId}`,
      );
      if (response && response.success) {
        let result = response.data;
        setSaleChanel(result?.name);
      }
    }
  };

  const fetchDelivery = async (data: string) => {
    try {
      const parsedData = JSON?.parse(data);
      setDataDeliveryInformation((prev: any) => ({
        ...prev,
        branchId: parsedData?.branchId,
        customerAddress: parsedData?.customerAddress,
        customerCommuneId: parsedData?.customerCommuneId,
        customerDistrictId: parsedData?.customerDistrictId,
        customerId: parsedData?.customerId,
        customerName: parsedData?.customerName,
        customerProvinceId: parsedData?.customerProvinceId,
        depId: parsedData?.depId,
        sourceType: parsedData?.sourceType,
        telephoneNumber: parsedData?.telephoneNumber,
        deliveryAppointmentTime: new Date(),
        deliveryFee: parsedData?.deliveryFee,
        timeDelivery: parsedData?.timeDelivery,
        timeDeliveryTime: parsedData?.timeDeliveryTime,
        weight: parsedData?.weight,
        width: parsedData?.width,
        length: parsedData?.length,
        height: parsedData?.height,
        feeShip: parsedData?.feeShip,
        description: parsedData?.description,
        status: parsedData?.status,
        typeShip: parsedData?.typeShip,
        to_address: parsedData?.to_address,
        distance: parsedData?.distance,
        to_addressid: parsedData?.to_addressid,
        transportName: parsedData?.transportName,
        listAddress: parsedData?.listAddress || [],
      }));
    } catch (error) {
      console.error("JSON parsing failed:", error);
    }
  };

  useEffect(() => {
    if (
      !location?.state ||
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "doi"
    )
      return;
    const fetchDataPaymentMethod = async () => {
      if (location.state?.orderNumber) {
        const url =
          location?.state?.actionType === "approved"
            ? `/api/v1/CreateSellItem/approve?orderNumber=${location.state?.orderNumber}`
            : location?.state?.actionType === "edit"
              ? `/api/v1/CreateSellItem/edit?orderNumber=${location.state?.orderNumber}`
              : `/api/v1/CreateSellItem/payment?orderNumber=${location.state?.orderNumber}`;

        const response = await repositoryPos.get<MessageResponse<any>>(url);

        if (response && response.success) {
          let result = response.data;
          setOrderHeader({ ...result.orderHeader });
          setOrderStatus(result?.orderHeader?.orderStatus);
          setBranchId(result?.orderHeader?.orgId);
          setShipingVendor(result?.orderHeader?.shipingVendor);
          const branchName = listBranch?.find(
            (item: any) => item?.id == result?.orderHeader?.orgId,
          );

          // Kiểm tra nếu branchName tồn tại trước khi set
          if (branchName) {
            setBranchName(branchName?.text);
          }
          if (!result?.orderDetail) return;
          setListAdd(result.orderDetail);
        }
      }
    };
    fetchDataPaymentMethod();
  }, [location, listBranch]);

  useEffect(() => {
    if (!location?.state) return;

    const handleFetchDataCustomer = async () => {
      const customerId =
        location?.state?.actionType === "doi"
          ? orderHeaderRef?.custId
          : orderHeader?.custId;

      if (customerId) {
        const customerReturn = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmCustomer/get-detail?id=${customerId}`,
        );

        setCustomerCheck((prev) => ({
          ...prev,
          active: customerReturn?.data?.active ?? false,
          address: customerReturn?.data?.address ?? "",
          birthOfDate: customerReturn?.data?.birthOfDate ?? null,
          code: customerReturn?.data?.code ?? "",
          contact: customerReturn?.data?.contact ?? "",
          description: customerReturn?.data?.description ?? "",
          email: customerReturn?.data?.email ?? "",
          fax: customerReturn?.data?.fax ?? "",
          groupId: customerReturn?.data?.groupId ?? 0,
          id: customerReturn?.data?.id ?? 0,
          name: customerReturn?.data?.name ?? "",
          companyName: customerReturn?.data?.companyName ?? "",
          sex: customerReturn?.data?.sex ?? null,
          taxCode: customerReturn?.data?.taxCode ?? "",
          telephoneNumber: customerReturn?.data?.telephoneNumber ?? "",
          type: customerReturn?.data?.type ?? 0,
          attribute1: customerReturn?.data?.attribute1 ?? "",
          attribute4: customerReturn?.data?.attribute4 ?? "",
          // debtLimit: customerReturn?.data?.debtLimit ?? 0,
          // debtTerm: customerReturn?.data?.debtTerm ?? 0,
        }));
      }
    };

    handleFetchDataCustomer();
  }, [orderHeader, location?.state, orderHeaderRef]);

  useEffect(() => {
    if (location?.state && !location?.state?.orderNumberOld) {
      fetchDetailSaleChanel(orderHeader?.saleChanelId);
      setContractcode(orderHeader?.contractcode);
      fetchDelivery(orderHeader?.attribute1 || "");
      setShipping(orderHeader?.shipngType);
      setAccountantId(orderHeader?.attribute2 || 0);
      handleGetNameAccountantById(orderHeader?.attribute2);
    }
  }, [orderHeader, location]);

  useEffect(() => {
    const fetchDepartment = async (DeptId: number) => {
      setDepartmentId(DeptId);
      const DeptName = listDepartment.find((item) => {
        return item.departmentId === DeptId;
      });
      if (DeptName?.name) {
        setDepartment(DeptName?.name || "");
      }
    };

    const fetchDetailEmployeeSales = async (
      SaleId: number,
      attribute18?: string,
    ) => {
      if (SaleId && SaleId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${SaleId}`,
        );
        if (response && response.success) {
          let result = response.data;
          setEmployeeSalesId(SaleId.toString());
          setEmployeeSalesName(result?.fullName);
          if (
            location?.state?.actionType !== "payment" &&
            location?.state?.actionType !== "approved" &&
            location?.state?.actionType !== "view" &&
            location?.state?.actionType !== "edit"
          ) {
            setEmployeeSalesRevenueId(SaleId.toString());
            setEmployeeSalesRevenueName(result?.fullName);
          } else {
            if (attribute18 && attribute18 != "0") {
              const response = await repositoryPos.get<MessageResponse<any>>(
                `/api/v1/TblDmEmployee/detail-employee?id=${attribute18}`,
              );
              if (response && response.success) {
                let resultRevenue = response.data;
                setEmployeeSalesRevenueId(attribute18 || "");
                setEmployeeSalesRevenueName(resultRevenue?.fullName);
              }
            }
          }
        }
      }
    };
    fetchDepartment(orderHeader?.deptId);
    fetchDetailEmployeeSales(orderHeader?.saleId, orderHeader?.attribute18);
  }, [
    orderHeader?.deptId,
    orderHeader?.saleId,
    listDepartment,
    location,
    orderHeader?.attribute18,
  ]);

  // logic xem đơn
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (location?.state?.actionType === "payment") {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
        }
      }

      if (location?.state?.actionType === "view") {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          setDataPayment(JSON.parse(response?.data?.orderHeader?.attribute9));
          console.log(
            "attribute9",
            JSON.parse(response?.data?.orderHeader?.attribute9),
          );
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
          setDataPaymentLatter(
            JSON.parse(response?.data?.orderHeader?.attribute20),
          );
          setPayLaterMethod(
            JSON.parse(response?.data?.orderHeader?.attribute20)
              ?.payLaterMethod,
          );
          setListAdd(response.data.orderDetail);
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // logic doi tra
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (location?.state?.actionType === "doi") {
        const url = `/api/v1/CreateSellItem/details-return?orderNumber=${location.state.orderNumberOld}&check=false`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          setOrderHeaderRef({ ...response?.data?.orderHeaderRef });
          setDataPayment(response?.data?.paymentCommands);
          setListAdd(response.data.orderDetail);
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // logic build pc

  useEffect(() => {
    if (orderHeader?.attribute19) {
      setListAdd((prevData) => {
        return prevData.map((item, i) => {
          return { ...item, attribute15: "1" };
        });
      });
      isFetchDataCalledRef.current = true;
    }
  }, [orderHeader?.attribute19]);

  // logic thanh toan sau
  useEffect(() => {
    const handlePayLaterMethodChange = (method: string) => {
      setPayLaterMethod(method);

      // Reset thông tin trả góp hoặc công nợ nếu phương thức thanh toán khác được chọn
      if (method !== "Trả góp") {
        setInstallmentInfo({
          installmentType: "",
          companyName: "",
          contractCode: "",
          cardType: "",
        });
      }
      if (method !== "Công nợ") {
        setDebtInfo({
          dueDate: "",
        });
      }
    };
    handlePayLaterMethodChange(payLaterMethod);
  }, [payLaterMethod]);

  useEffect(() => {
    if (
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "approved"
    ) {
      // Reset shippingVendor khi shipping thay đổi
      setShipingVendor("");

      // Cập nhật deliveryFee về 0
      setDataDeliveryInformation((prev: any) => {
        if (!prev) return prev; // Kiểm tra nếu prev là null hoặc undefined
        return {
          ...prev,
          deliveryFee: 0, // Cập nhật deliveryFee về 0
        };
      });
    }
  }, [shipping, location?.state?.actionType]);

  useEffect(() => {
    // Call API to check permission for creating wholesale order
    const checkPermission = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        "/api/v1/CreateSellItem/check-create",
      );
      // New logic: if response is undefined => no permission, if response.data is empty string => have permission
      if (response === undefined) {
        navigate("/");
      }
    };
    checkPermission();
  }, [navigate]);

  useEffect(() => {
    if (shipping === "Nhận tại cửa hàng") {
      setDataDeliveryInformation({
        ...dataDeliveryInformation,
        typeShip: "",
        shippingVendor: "",
      });
      setIsHaveShipping(false);
    }
  }, [shipping]);

  return (
    <Box style={{ position: "relative" }}>
      <LoadingOverlay
        visible={loading}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
        loaderProps={{ color: "blue", type: "bars" }}
      />
      <div
        style={{
          ...getStyle(true),
        }}
      >
        {titleSell()}
      </div>

      <PanelGroup direction="horizontal" id="group" style={{ width: "100%" }}>
        <Panel
          defaultSize={
            isCollapse ? 0 : location?.state?.actionType === "view" ? 35 : 45
          }
          minSize={isCollapse ? 0 : 35}
          maxSize={65}
          collapsible
          style={{
            transition: "0.3s ease",
            display: isCollapse ? "none" : "block",
          }}
        >
          <Collapse
            in={!isCollapse}
            transitionDuration={100}
            transitionTimingFunction="ease-in-out"
            h={"100%"}
          >
            <Card h="100%" p={0} shadow="sm" radius="md" withBorder>
              {formOrderHeader()}
            </Card>
          </Collapse>
        </Panel>

        {!isCollapse && <PanelResizeHandle id="resize-handle" />}

        <Panel
          defaultSize={isCollapse ? 100 : 55}
          minSize={35}
          maxSize={isCollapse ? 100 : 65}
          style={{
            width: isCollapse ? "100%" : "auto",
            transition: "width 0.3s ease",
          }}
        >
          <Flex direction={"column"}>
            <MantineReactTable table={table} />

            {/* Thêm thanh hiển thị thông tin đơn hàng ở đây */}
            {!containsDT(orderHeader?.orderNumber) &&
              // !location?.state?.isReadOnly && (
              true && (
                <Card
                  shadow="sm"
                  radius="md"
                  withBorder
                  p="md"
                  style={{
                    backgroundColor: "#f9f9f9",
                    borderRadius: "10px",
                    padding: "20px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Grid>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Số lượng:
                      </Text>
                      <Text className={styles.infoValueStyle}>
                        {getTotalQuality(listAdd)}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng tiền hàng:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={totalAmount}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng khuyến mãi:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={totalKM === 0 ? 0 : `-${totalKM}`}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng xin giảm:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={
                            (totalXGDetail ?? 0) +
                              (orderHeader?.discountAddedTotal ?? 0) ===
                            0
                              ? 0
                              : `-${
                                  (totalXGDetail ?? 0) +
                                  (orderHeader?.discountAddedTotal ?? 0)
                                }`
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Thanh toán:
                      </Text>
                      <Text fw={"bold"} style={{ color: "red" }}>
                        <NumberFormatter
                          value={payableAmount}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                  </Grid>
                </Card>
              )}
          </Flex>
        </Panel>
      </PanelGroup>
      {/* {idPrint && (
        <PrintInvoice
          isDVT={listBranch?.find((item: any) => Number(item.value) === Number(branchId))?.attr6 === "DVT"}
          idPrint={idPrint}
          setIdPrint={setIdPrint}
          isPrinting={isPrinting}
          setIsPrinting={setIsPrinting}
        />
      )} */}

      {/* Discount Suggestion Modal */}
      <DiscountSuggestionModal
        opened={discountModalOpened}
        onClose={() => {
          setDiscountModalOpened(false);
          setDiscountSuggestionData(null);
        }}
        discountData={discountSuggestionData}
        loading={discountLoading}
        userAuth={userAuth}
        isRetail={false}
        listAdd={listAdd}
      />

      {/* Discount Selection Modal */}
      <DiscountSelectionModal
        opened={discountSelectionOpened}
        onClose={() => {
          setDiscountSelectionOpened(false);
          setSelectedRowForDiscount(null);
          setCurrentDiscountOptions([]);
        }}
        discountOptions={currentDiscountOptions}
        onSelectDiscount={handleSelectDiscount}
      />
    </Box>
  );
};

export default WholeSale;
